import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export var A3AnalysisTypeEnum;
(function (A3AnalysisTypeEnum) {
    A3AnalysisTypeEnum["AnomalyExplanation"] = "ANOMALY_EXPLANATION";
    A3AnalysisTypeEnum["Change"] = "CHANGE";
    A3AnalysisTypeEnum["Data"] = "DATA";
    A3AnalysisTypeEnum["RelatedInsights"] = "RELATED_INSIGHTS";
    A3AnalysisTypeEnum["Table"] = "TABLE";
    A3AnalysisTypeEnum["Unknown"] = "UNKNOWN";
    A3AnalysisTypeEnum["Visualization"] = "VISUALIZATION";
})(A3AnalysisTypeEnum || (A3AnalysisTypeEnum = {}));
export var A3ColumnType;
(function (A3ColumnType) {
    A3ColumnType["Attribute"] = "ATTRIBUTE";
    A3ColumnType["Measure"] = "MEASURE";
})(A3ColumnType || (A3ColumnType = {}));
export var AiAnswerState;
(function (AiAnswerState) {
    AiAnswerState["Disabled"] = "DISABLED";
    AiAnswerState["Enabled"] = "ENABLED";
    AiAnswerState["NotSet"] = "NOT_SET";
})(AiAnswerState || (AiAnswerState = {}));
export var AccessLevel;
(function (AccessLevel) {
    AccessLevel["Modify"] = "MODIFY";
    AccessLevel["ReadOnly"] = "READ_ONLY";
})(AccessLevel || (AccessLevel = {}));
export var AccessLevelEnum;
(function (AccessLevelEnum) {
    AccessLevelEnum["Full"] = "FULL";
    AccessLevelEnum["ReportBookView"] = "REPORT_BOOK_VIEW";
})(AccessLevelEnum || (AccessLevelEnum = {}));
export var AccessMode;
(function (AccessMode) {
    AccessMode["Modify"] = "MODIFY";
    AccessMode["ModifyMetadataReadContent"] = "MODIFY_METADATA_READ_CONTENT";
    AccessMode["NoAccess"] = "NO_ACCESS";
    AccessMode["ReadMetadataModifyContent"] = "READ_METADATA_MODIFY_CONTENT";
    AccessMode["ReadOnly"] = "READ_ONLY";
})(AccessMode || (AccessMode = {}));
export var AccessType;
(function (AccessType) {
    AccessType["User"] = "USER";
    AccessType["UserGroup"] = "USER_GROUP";
})(AccessType || (AccessType = {}));
export var ActionAvailability;
(function (ActionAvailability) {
    ActionAvailability["ContextMenuOnly"] = "CONTEXT_MENU_ONLY";
    ActionAvailability["Global"] = "GLOBAL";
    ActionAvailability["Worksheet"] = "WORKSHEET";
})(ActionAvailability || (ActionAvailability = {}));
export var ActionContext;
(function (ActionContext) {
    ActionContext["ContextMenu"] = "CONTEXT_MENU";
    ActionContext["Menu"] = "MENU";
    ActionContext["None"] = "NONE";
    ActionContext["Primary"] = "PRIMARY";
})(ActionContext || (ActionContext = {}));
export var ActionSelect;
(function (ActionSelect) {
    ActionSelect["Apikey"] = "APIKEY";
    ActionSelect["Basic"] = "BASIC";
    ActionSelect["Bearer"] = "BEARER";
    ActionSelect["None"] = "NONE";
})(ActionSelect || (ActionSelect = {}));
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["App"] = "APP";
    ActionTypes["Callback"] = "CALLBACK";
    ActionTypes["Url"] = "URL";
})(ActionTypes || (ActionTypes = {}));
export var AggregateFunctionTypeEnum;
(function (AggregateFunctionTypeEnum) {
    AggregateFunctionTypeEnum["Aggregate"] = "AGGREGATE";
    AggregateFunctionTypeEnum["AggrDistinct"] = "AGGR_DISTINCT";
    AggregateFunctionTypeEnum["ApproxAggrDistinct"] = "APPROX_AGGR_DISTINCT";
    AggregateFunctionTypeEnum["ApproxAggrDistinctMerge"] = "APPROX_AGGR_DISTINCT_MERGE";
    AggregateFunctionTypeEnum["ApproxCountDistinct"] = "APPROX_COUNT_DISTINCT";
    AggregateFunctionTypeEnum["Average"] = "AVERAGE";
    AggregateFunctionTypeEnum["Count"] = "COUNT";
    AggregateFunctionTypeEnum["CountDistinct"] = "COUNT_DISTINCT";
    AggregateFunctionTypeEnum["Growth"] = "GROWTH";
    AggregateFunctionTypeEnum["Max"] = "MAX";
    AggregateFunctionTypeEnum["Median"] = "MEDIAN";
    AggregateFunctionTypeEnum["Min"] = "MIN";
    AggregateFunctionTypeEnum["None"] = "NONE";
    AggregateFunctionTypeEnum["Percentile"] = "PERCENTILE";
    AggregateFunctionTypeEnum["Rank"] = "RANK";
    AggregateFunctionTypeEnum["RankPercentile"] = "RANK_PERCENTILE";
    AggregateFunctionTypeEnum["SqlBoolAggregateOp"] = "SQL_BOOL_AGGREGATE_OP";
    AggregateFunctionTypeEnum["SqlDateAggregateOp"] = "SQL_DATE_AGGREGATE_OP";
    AggregateFunctionTypeEnum["SqlDateTimeAggregateOp"] = "SQL_DATE_TIME_AGGREGATE_OP";
    AggregateFunctionTypeEnum["SqlDoubleAggregateOp"] = "SQL_DOUBLE_AGGREGATE_OP";
    AggregateFunctionTypeEnum["SqlIntAggregateOp"] = "SQL_INT_AGGREGATE_OP";
    AggregateFunctionTypeEnum["SqlStringAggregateOp"] = "SQL_STRING_AGGREGATE_OP";
    AggregateFunctionTypeEnum["SqlTimeAggregateOp"] = "SQL_TIME_AGGREGATE_OP";
    AggregateFunctionTypeEnum["StdDeviation"] = "STD_DEVIATION";
    AggregateFunctionTypeEnum["Sum"] = "SUM";
    AggregateFunctionTypeEnum["TableAggr"] = "TABLE_AGGR";
    AggregateFunctionTypeEnum["Variance"] = "VARIANCE";
})(AggregateFunctionTypeEnum || (AggregateFunctionTypeEnum = {}));
export var AggregationType;
(function (AggregationType) {
    AggregationType["AggregateDistinct"] = "AGGREGATE_DISTINCT";
    AggregationType["Average"] = "AVERAGE";
    AggregationType["Count"] = "COUNT";
    AggregationType["Max"] = "MAX";
    AggregationType["Median"] = "MEDIAN";
    AggregationType["Min"] = "MIN";
    AggregationType["None"] = "NONE";
    AggregationType["Percentile"] = "PERCENTILE";
    AggregationType["Rank"] = "RANK";
    AggregationType["RankPercentile"] = "RANK_PERCENTILE";
    AggregationType["StdDeviation"] = "STD_DEVIATION";
    AggregationType["Sum"] = "SUM";
    AggregationType["UniqueCount"] = "UNIQUE_COUNT";
    AggregationType["Variance"] = "VARIANCE";
})(AggregationType || (AggregationType = {}));
export var AlertType;
(function (AlertType) {
    AlertType["Anomaly"] = "Anomaly";
    AlertType["Scheduled"] = "Scheduled";
    AlertType["ScheduledByAttribute"] = "ScheduledByAttribute";
    AlertType["Threshold"] = "Threshold";
    AlertType["ThresholdByAttribute"] = "ThresholdByAttribute";
})(AlertType || (AlertType = {}));
export var AnalysisActionResponseStatus;
(function (AnalysisActionResponseStatus) {
    AnalysisActionResponseStatus["Done"] = "DONE";
    AnalysisActionResponseStatus["Failed"] = "FAILED";
})(AnalysisActionResponseStatus || (AnalysisActionResponseStatus = {}));
export var AnalysisActionType;
(function (AnalysisActionType) {
    AnalysisActionType["Delete"] = "DELETE";
    AnalysisActionType["Save"] = "SAVE";
})(AnalysisActionType || (AnalysisActionType = {}));
export var AnalysisAlgorithmTypeEnum;
(function (AnalysisAlgorithmTypeEnum) {
    AnalysisAlgorithmTypeEnum["AbsDiffMajority"] = "ABS_DIFF_MAJORITY";
    AnalysisAlgorithmTypeEnum["AnomalyExplanation"] = "ANOMALY_EXPLANATION";
    AnalysisAlgorithmTypeEnum["CrossCorrelation"] = "CROSS_CORRELATION";
    AnalysisAlgorithmTypeEnum["Forecast"] = "FORECAST";
    AnalysisAlgorithmTypeEnum["KeyDrivers"] = "KEY_DRIVERS";
    AnalysisAlgorithmTypeEnum["LinearRegression"] = "LINEAR_REGRESSION";
    AnalysisAlgorithmTypeEnum["MadMedian"] = "MAD_MEDIAN";
    AnalysisAlgorithmTypeEnum["Shesd"] = "SHESD";
    AnalysisAlgorithmTypeEnum["StdevMean"] = "STDEV_MEAN";
    AnalysisAlgorithmTypeEnum["TrendAnalysis"] = "TREND_ANALYSIS";
    AnalysisAlgorithmTypeEnum["WhatIf"] = "WHAT_IF";
})(AnalysisAlgorithmTypeEnum || (AnalysisAlgorithmTypeEnum = {}));
export var AnalysisClassEnum;
(function (AnalysisClassEnum) {
    AnalysisClassEnum["AnomalyExplanation"] = "ANOMALY_EXPLANATION";
    AnalysisClassEnum["CrossCorrelation"] = "CROSS_CORRELATION";
    AnalysisClassEnum["CustomRAnalysis"] = "CUSTOM_R_ANALYSIS";
    AnalysisClassEnum["DiffExplanation"] = "DIFF_EXPLANATION";
    AnalysisClassEnum["Forecast"] = "FORECAST";
    AnalysisClassEnum["KeyDrivers"] = "KEY_DRIVERS";
    AnalysisClassEnum["OutlierDetection"] = "OUTLIER_DETECTION";
    AnalysisClassEnum["TrendAnalysis"] = "TREND_ANALYSIS";
    AnalysisClassEnum["WhatIf"] = "WHAT_IF";
})(AnalysisClassEnum || (AnalysisClassEnum = {}));
export var AnalysisSortBy;
(function (AnalysisSortBy) {
    AnalysisSortBy["ExpiresIn"] = "EXPIRES_IN";
    AnalysisSortBy["LastAnalyzed"] = "LAST_ANALYZED";
    AnalysisSortBy["Name"] = "NAME";
    AnalysisSortBy["Status"] = "STATUS";
    AnalysisSortBy["TriggeredBy"] = "TRIGGERED_BY";
})(AnalysisSortBy || (AnalysisSortBy = {}));
export var AnalysisState;
(function (AnalysisState) {
    AnalysisState["Completed"] = "COMPLETED";
    AnalysisState["Failed"] = "FAILED";
    AnalysisState["NoInsights"] = "NO_INSIGHTS";
    AnalysisState["Paused"] = "PAUSED";
    AnalysisState["Running"] = "RUNNING";
    AnalysisState["Scheduled"] = "SCHEDULED";
})(AnalysisState || (AnalysisState = {}));
export var AnalysisType;
(function (AnalysisType) {
    AnalysisType["Forecast"] = "FORECAST";
    AnalysisType["KeyDrivers"] = "KEY_DRIVERS";
    AnalysisType["KpiAnomalyDetection"] = "KPI_ANOMALY_DETECTION";
    AnalysisType["WhatIf"] = "WHAT_IF";
})(AnalysisType || (AnalysisType = {}));
export var AnomalyDirectionEnum;
(function (AnomalyDirectionEnum) {
    AnomalyDirectionEnum["High"] = "HIGH";
    AnomalyDirectionEnum["Low"] = "LOW";
    AnomalyDirectionEnum["Unknown"] = "UNKNOWN";
})(AnomalyDirectionEnum || (AnomalyDirectionEnum = {}));
export var AnswerColumnCustomCalendarType;
(function (AnswerColumnCustomCalendarType) {
    AnswerColumnCustomCalendarType["EndOfDateBucket"] = "END_OF_DATE_BUCKET";
    AnswerColumnCustomCalendarType["FormattedDateBucketString"] = "FORMATTED_DATE_BUCKET_STRING";
})(AnswerColumnCustomCalendarType || (AnswerColumnCustomCalendarType = {}));
export var AnswerColumnEffectiveType;
(function (AnswerColumnEffectiveType) {
    AnswerColumnEffectiveType["Attribute"] = "ATTRIBUTE";
    AnswerColumnEffectiveType["Measure"] = "MEASURE";
    AnswerColumnEffectiveType["Unknown"] = "UNKNOWN";
})(AnswerColumnEffectiveType || (AnswerColumnEffectiveType = {}));
export var AnswerColumnFormatType;
(function (AnswerColumnFormatType) {
    AnswerColumnFormatType["Currency"] = "CURRENCY";
    AnswerColumnFormatType["None"] = "NONE";
    AnswerColumnFormatType["Percentage"] = "PERCENTAGE";
})(AnswerColumnFormatType || (AnswerColumnFormatType = {}));
export var AnswerColumnPropVersion;
(function (AnswerColumnPropVersion) {
    AnswerColumnPropVersion["PreV1"] = "PRE_V1";
    AnswerColumnPropVersion["V1"] = "V1";
})(AnswerColumnPropVersion || (AnswerColumnPropVersion = {}));
export var AnswerColumnSortType;
(function (AnswerColumnSortType) {
    AnswerColumnSortType["Ascending"] = "ASCENDING";
    AnswerColumnSortType["Descending"] = "DESCENDING";
    AnswerColumnSortType["Unknown"] = "UNKNOWN";
})(AnswerColumnSortType || (AnswerColumnSortType = {}));
export var AnswerColumnType;
(function (AnswerColumnType) {
    AnswerColumnType["FilterColumn"] = "FILTER_COLUMN";
    AnswerColumnType["GrowthColumn"] = "GROWTH_COLUMN";
    AnswerColumnType["SageColumn"] = "SAGE_COLUMN";
    AnswerColumnType["VizSpecificColumn"] = "VIZ_SPECIFIC_COLUMN";
})(AnswerColumnType || (AnswerColumnType = {}));
export var AnswerContextType;
(function (AnswerContextType) {
    AnswerContextType["ChangeAnalysis"] = "CHANGE_ANALYSIS";
    AnswerContextType["CohortAnswer"] = "COHORT_ANSWER";
    AnswerContextType["DownloadAnswer"] = "DOWNLOAD_ANSWER";
    AnswerContextType["EditPinboardViz"] = "EDIT_PINBOARD_VIZ";
    AnswerContextType["ExploreAnswer"] = "EXPLORE_ANSWER";
    AnswerContextType["KpiMonitor"] = "KPI_MONITOR";
    AnswerContextType["NewAnswer"] = "NEW_ANSWER";
    AnswerContextType["PinboardViz"] = "PINBOARD_VIZ";
    AnswerContextType["SavedAnswer"] = "SAVED_ANSWER";
    AnswerContextType["SpotterNewAnswer"] = "SPOTTER_NEW_ANSWER";
    AnswerContextType["SpotIq"] = "SPOT_IQ";
    AnswerContextType["UnaggregatedAnswer"] = "UNAGGREGATED_ANSWER";
    AnswerContextType["View"] = "VIEW";
})(AnswerContextType || (AnswerContextType = {}));
export var AnswerJoinPathAmbiguityErrorType;
(function (AnswerJoinPathAmbiguityErrorType) {
    AnswerJoinPathAmbiguityErrorType["JoinPathResolutionRequired"] = "JOIN_PATH_RESOLUTION_REQUIRED";
    AnswerJoinPathAmbiguityErrorType["OtherBackendIssue"] = "OTHER_BACKEND_ISSUE";
})(AnswerJoinPathAmbiguityErrorType || (AnswerJoinPathAmbiguityErrorType = {}));
export var AssociatedActionContext;
(function (AssociatedActionContext) {
    AssociatedActionContext["ContextMenu"] = "CONTEXT_MENU";
    AssociatedActionContext["Menu"] = "MENU";
    AssociatedActionContext["None"] = "NONE";
    AssociatedActionContext["Primary"] = "PRIMARY";
})(AssociatedActionContext || (AssociatedActionContext = {}));
export var AtlasJoinType;
(function (AtlasJoinType) {
    AtlasJoinType["Cross"] = "CROSS";
    AtlasJoinType["Inner"] = "INNER";
    AtlasJoinType["Left"] = "LEFT";
    AtlasJoinType["Outer"] = "OUTER";
    AtlasJoinType["Right"] = "RIGHT";
})(AtlasJoinType || (AtlasJoinType = {}));
export var Augmentation_Column_Type;
(function (Augmentation_Column_Type) {
    Augmentation_Column_Type["AugmentData"] = "AUGMENT_DATA";
    Augmentation_Column_Type["TsObject"] = "TS_OBJECT";
})(Augmentation_Column_Type || (Augmentation_Column_Type = {}));
export var AuthenticationType;
(function (AuthenticationType) {
    AuthenticationType["Extoauth"] = "EXTOAUTH";
    AuthenticationType["Iam"] = "IAM";
    AuthenticationType["KeyPair"] = "KEY_PAIR";
    AuthenticationType["Oauth"] = "OAUTH";
    AuthenticationType["OauthClientCredentials"] = "OAUTH_CLIENT_CREDENTIALS";
    AuthenticationType["OauthWithPkce"] = "OAUTH_WITH_PKCE";
    AuthenticationType["OauthWithServicePrincipal"] = "OAUTH_WITH_SERVICE_PRINCIPAL";
    AuthenticationType["PersonalAccessToken"] = "PERSONAL_ACCESS_TOKEN";
    AuthenticationType["ServiceAccount"] = "SERVICE_ACCOUNT";
})(AuthenticationType || (AuthenticationType = {}));
export var AxisTypes;
(function (AxisTypes) {
    AxisTypes["Color"] = "COLOR";
    AxisTypes["X"] = "X";
    AxisTypes["Y"] = "Y";
})(AxisTypes || (AxisTypes = {}));
export var BackgroundFormatTypes;
(function (BackgroundFormatTypes) {
    BackgroundFormatTypes["Gradient"] = "GRADIENT";
    BackgroundFormatTypes["Solid"] = "SOLID";
})(BackgroundFormatTypes || (BackgroundFormatTypes = {}));
export var BannerLevel;
(function (BannerLevel) {
    BannerLevel["Cluster"] = "CLUSTER";
    BannerLevel["Org"] = "ORG";
})(BannerLevel || (BannerLevel = {}));
export var BulkEditColumAttributes;
(function (BulkEditColumAttributes) {
    BulkEditColumAttributes["Additive"] = "ADDITIVE";
    BulkEditColumAttributes["Aggregation"] = "AGGREGATION";
    BulkEditColumAttributes["AttributionDimension"] = "ATTRIBUTION_DIMENSION";
    BulkEditColumAttributes["CalendarType"] = "CALENDAR_TYPE";
    BulkEditColumAttributes["ColumnType"] = "COLUMN_TYPE";
    BulkEditColumAttributes["CurrencyInfo"] = "CURRENCY_INFO";
    BulkEditColumAttributes["FormatPattern"] = "FORMAT_PATTERN";
    BulkEditColumAttributes["GeoConfig"] = "GEO_CONFIG";
    BulkEditColumAttributes["Hidden"] = "HIDDEN";
    BulkEditColumAttributes["Index"] = "INDEX";
    BulkEditColumAttributes["Name"] = "NAME";
    BulkEditColumAttributes["Search"] = "SEARCH";
    BulkEditColumAttributes["SpotIqPreference"] = "SPOT_IQ_PREFERENCE";
})(BulkEditColumAttributes || (BulkEditColumAttributes = {}));
export var CcaColumnConfigAction;
(function (CcaColumnConfigAction) {
    CcaColumnConfigAction["Reset"] = "RESET";
    CcaColumnConfigAction["Save"] = "SAVE";
})(CcaColumnConfigAction || (CcaColumnConfigAction = {}));
export var CcaColumnConfigType;
(function (CcaColumnConfigType) {
    CcaColumnConfigType["Chart"] = "CHART";
    CcaColumnConfigType["Ubr"] = "UBR";
    CcaColumnConfigType["User"] = "USER";
})(CcaColumnConfigType || (CcaColumnConfigType = {}));
export var CategoryType;
(function (CategoryType) {
    CategoryType["Currency"] = "CURRENCY";
    CategoryType["Custom"] = "CUSTOM";
    CategoryType["Number"] = "NUMBER";
    CategoryType["Percentage"] = "PERCENTAGE";
})(CategoryType || (CategoryType = {}));
export var ChangeAnalysisInsightStatus;
(function (ChangeAnalysisInsightStatus) {
    ChangeAnalysisInsightStatus["ChangeAnalysisDataFetchForAihFailed"] = "CHANGE_ANALYSIS_DATA_FETCH_FOR_AIH_FAILED";
    ChangeAnalysisInsightStatus["ChangeAnalysisFailed"] = "CHANGE_ANALYSIS_FAILED";
    ChangeAnalysisInsightStatus["GroupAggregateNotSupported"] = "GROUP_AGGREGATE_NOT_SUPPORTED";
    ChangeAnalysisInsightStatus["StatusCodeOk"] = "STATUS_CODE_OK";
})(ChangeAnalysisInsightStatus || (ChangeAnalysisInsightStatus = {}));
export var ChartResponsiveLayout;
(function (ChartResponsiveLayout) {
    ChartResponsiveLayout["AutoOff"] = "AUTO_OFF";
    ChartResponsiveLayout["AutoOn"] = "AUTO_ON";
    ChartResponsiveLayout["UserPreferredOff"] = "USER_PREFERRED_OFF";
    ChartResponsiveLayout["UserPreferredOn"] = "USER_PREFERRED_ON";
})(ChartResponsiveLayout || (ChartResponsiveLayout = {}));
export var ChartSpecificColumnType;
(function (ChartSpecificColumnType) {
    ChartSpecificColumnType["MeasureNames"] = "MEASURE_NAMES";
    ChartSpecificColumnType["MeasureValues"] = "MEASURE_VALUES";
    ChartSpecificColumnType["Undefined"] = "UNDEFINED";
})(ChartSpecificColumnType || (ChartSpecificColumnType = {}));
export var ChartType;
(function (ChartType) {
    ChartType["AdvancedArea"] = "ADVANCED_AREA";
    ChartType["AdvancedBar"] = "ADVANCED_BAR";
    ChartType["AdvancedColumn"] = "ADVANCED_COLUMN";
    ChartType["AdvancedLine"] = "ADVANCED_LINE";
    ChartType["AdvancedLineColumn"] = "ADVANCED_LINE_COLUMN";
    ChartType["AdvancedLineStackedColumn"] = "ADVANCED_LINE_STACKED_COLUMN";
    ChartType["AdvancedPivotTable"] = "ADVANCED_PIVOT_TABLE";
    ChartType["AdvancedStackedArea"] = "ADVANCED_STACKED_AREA";
    ChartType["AdvancedStackedBar"] = "ADVANCED_STACKED_BAR";
    ChartType["AdvancedStackedColumn"] = "ADVANCED_STACKED_COLUMN";
    ChartType["Area"] = "AREA";
    ChartType["Bar"] = "BAR";
    ChartType["Bubble"] = "BUBBLE";
    ChartType["Candlestick"] = "CANDLESTICK";
    ChartType["Column"] = "COLUMN";
    ChartType["CustomChart"] = "CUSTOM_CHART";
    ChartType["Funnel"] = "FUNNEL";
    ChartType["GeoArea"] = "GEO_AREA";
    ChartType["GeoBubble"] = "GEO_BUBBLE";
    ChartType["GeoEarthArea"] = "GEO_EARTH_AREA";
    ChartType["GeoEarthBar"] = "GEO_EARTH_BAR";
    ChartType["GeoEarthBubble"] = "GEO_EARTH_BUBBLE";
    ChartType["GeoEarthGraph"] = "GEO_EARTH_GRAPH";
    ChartType["GeoEarthHeatmap"] = "GEO_EARTH_HEATMAP";
    ChartType["GeoHeatmap"] = "GEO_HEATMAP";
    ChartType["GridTable"] = "GRID_TABLE";
    ChartType["Heatmap"] = "HEATMAP";
    ChartType["Kpi"] = "KPI";
    ChartType["Line"] = "LINE";
    ChartType["LineColumn"] = "LINE_COLUMN";
    ChartType["LineStackedColumn"] = "LINE_STACKED_COLUMN";
    ChartType["MuzeStudio"] = "MUZE_STUDIO";
    ChartType["None"] = "NONE";
    ChartType["Pareto"] = "PARETO";
    ChartType["Pie"] = "PIE";
    ChartType["PivotTable"] = "PIVOT_TABLE";
    ChartType["Sankey"] = "SANKEY";
    ChartType["Scatter"] = "SCATTER";
    ChartType["SpiderWeb"] = "SPIDER_WEB";
    ChartType["StackedArea"] = "STACKED_AREA";
    ChartType["StackedBar"] = "STACKED_BAR";
    ChartType["StackedColumn"] = "STACKED_COLUMN";
    ChartType["Treemap"] = "TREEMAP";
    ChartType["Waterfall"] = "WATERFALL";
    ChartType["WhiskerScatter"] = "WHISKER_SCATTER";
})(ChartType || (ChartType = {}));
export var ChartVizPropVersion;
(function (ChartVizPropVersion) {
    ChartVizPropVersion["V2"] = "V2";
    ChartVizPropVersion["V2Dot1"] = "V2DOT1";
    ChartVizPropVersion["V3"] = "V3";
    ChartVizPropVersion["V4"] = "V4";
    ChartVizPropVersion["V4Dot1"] = "V4DOT1";
    ChartVizPropVersion["V4Dot2"] = "V4DOT2";
})(ChartVizPropVersion || (ChartVizPropVersion = {}));
export var ChipType;
(function (ChipType) {
    ChipType["Filter"] = "FILTER";
    ChipType["Parameter"] = "PARAMETER";
})(ChipType || (ChipType = {}));
export var ClientAction;
(function (ClientAction) {
    ClientAction["ChangeVisualConfiguration"] = "CHANGE_VISUAL_CONFIGURATION";
    ClientAction["HighlightFilters"] = "HIGHLIGHT_FILTERS";
    ClientAction["HighlightTable"] = "HIGHLIGHT_TABLE";
    ClientAction["SeeResults"] = "SEE_RESULTS";
})(ClientAction || (ClientAction = {}));
export var CohortConditionCombinationType;
(function (CohortConditionCombinationType) {
    CohortConditionCombinationType["All"] = "ALL";
    CohortConditionCombinationType["Any"] = "ANY";
})(CohortConditionCombinationType || (CohortConditionCombinationType = {}));
export var CohortGroupingType;
(function (CohortGroupingType) {
    CohortGroupingType["BinBased"] = "BIN_BASED";
    CohortGroupingType["ColumnBased"] = "COLUMN_BASED";
    CohortGroupingType["GroupBased"] = "GROUP_BASED";
})(CohortGroupingType || (CohortGroupingType = {}));
export var CohortType;
(function (CohortType) {
    CohortType["Advanced"] = "ADVANCED";
    CohortType["BinBased"] = "BIN_BASED";
    CohortType["ColumnBased"] = "COLUMN_BASED";
    CohortType["GroupBased"] = "GROUP_BASED";
    CohortType["Simple"] = "SIMPLE";
})(CohortType || (CohortType = {}));
export var ColumnAggregationType;
(function (ColumnAggregationType) {
    ColumnAggregationType["Aggregate"] = "AGGREGATE";
    ColumnAggregationType["AggregateDistinct"] = "AGGREGATE_DISTINCT";
    ColumnAggregationType["ApproxAggrDistinct"] = "APPROX_AGGR_DISTINCT";
    ColumnAggregationType["ApproxAggrDistinctMerge"] = "APPROX_AGGR_DISTINCT_MERGE";
    ColumnAggregationType["ApproxCountDistinct"] = "APPROX_COUNT_DISTINCT";
    ColumnAggregationType["Average"] = "AVERAGE";
    ColumnAggregationType["Count"] = "COUNT";
    ColumnAggregationType["CountDistinct"] = "COUNT_DISTINCT";
    ColumnAggregationType["CumulativeAverage"] = "CUMULATIVE_AVERAGE";
    ColumnAggregationType["CumulativeCount"] = "CUMULATIVE_COUNT";
    ColumnAggregationType["CumulativeMax"] = "CUMULATIVE_MAX";
    ColumnAggregationType["CumulativeMin"] = "CUMULATIVE_MIN";
    ColumnAggregationType["CumulativeSum"] = "CUMULATIVE_SUM";
    ColumnAggregationType["Growth"] = "GROWTH";
    ColumnAggregationType["Max"] = "MAX";
    ColumnAggregationType["Median"] = "MEDIAN";
    ColumnAggregationType["Min"] = "MIN";
    ColumnAggregationType["MovingAverage"] = "MOVING_AVERAGE";
    ColumnAggregationType["MovingCount"] = "MOVING_COUNT";
    ColumnAggregationType["MovingMax"] = "MOVING_MAX";
    ColumnAggregationType["MovingMin"] = "MOVING_MIN";
    ColumnAggregationType["MovingSum"] = "MOVING_SUM";
    ColumnAggregationType["None"] = "NONE";
    ColumnAggregationType["Percentile"] = "PERCENTILE";
    ColumnAggregationType["Rank"] = "RANK";
    ColumnAggregationType["RankPercentile"] = "RANK_PERCENTILE";
    ColumnAggregationType["SqlBoolAggregateOp"] = "SQL_BOOL_AGGREGATE_OP";
    ColumnAggregationType["SqlDateAggregateOp"] = "SQL_DATE_AGGREGATE_OP";
    ColumnAggregationType["SqlDateTimeAggregateOp"] = "SQL_DATE_TIME_AGGREGATE_OP";
    ColumnAggregationType["SqlDoubleAggregateOp"] = "SQL_DOUBLE_AGGREGATE_OP";
    ColumnAggregationType["SqlIntAggregateOp"] = "SQL_INT_AGGREGATE_OP";
    ColumnAggregationType["SqlStringAggregateOp"] = "SQL_STRING_AGGREGATE_OP";
    ColumnAggregationType["SqlTimeAggregateOp"] = "SQL_TIME_AGGREGATE_OP";
    ColumnAggregationType["StdDeviation"] = "STD_DEVIATION";
    ColumnAggregationType["Sum"] = "SUM";
    ColumnAggregationType["TableAggr"] = "TABLE_AGGR";
    ColumnAggregationType["Variance"] = "VARIANCE";
})(ColumnAggregationType || (ColumnAggregationType = {}));
export var ColumnDataTypeEnum;
(function (ColumnDataTypeEnum) {
    ColumnDataTypeEnum["Bool"] = "BOOL";
    ColumnDataTypeEnum["Char"] = "CHAR";
    ColumnDataTypeEnum["Date"] = "DATE";
    ColumnDataTypeEnum["DateNum"] = "DATE_NUM";
    ColumnDataTypeEnum["DateNumAbsDay"] = "DATE_NUM_ABS_DAY";
    ColumnDataTypeEnum["DateNumAbsHour"] = "DATE_NUM_ABS_HOUR";
    ColumnDataTypeEnum["DateNumAbsMonth"] = "DATE_NUM_ABS_MONTH";
    ColumnDataTypeEnum["DateNumAbsQuarter"] = "DATE_NUM_ABS_QUARTER";
    ColumnDataTypeEnum["DateNumAbsWeek"] = "DATE_NUM_ABS_WEEK";
    ColumnDataTypeEnum["DateNumAbsYear"] = "DATE_NUM_ABS_YEAR";
    ColumnDataTypeEnum["DateNumDayInMonth"] = "DATE_NUM_DAY_IN_MONTH";
    ColumnDataTypeEnum["DateNumDayInQuarter"] = "DATE_NUM_DAY_IN_QUARTER";
    ColumnDataTypeEnum["DateNumDayInYear"] = "DATE_NUM_DAY_IN_YEAR";
    ColumnDataTypeEnum["DateNumDayOfWeek"] = "DATE_NUM_DAY_OF_WEEK";
    ColumnDataTypeEnum["DateNumDayOfWeekStr"] = "DATE_NUM_DAY_OF_WEEK_STR";
    ColumnDataTypeEnum["DateNumHourInDay"] = "DATE_NUM_HOUR_IN_DAY";
    ColumnDataTypeEnum["DateNumMonthInQuarter"] = "DATE_NUM_MONTH_IN_QUARTER";
    ColumnDataTypeEnum["DateNumMonthInYear"] = "DATE_NUM_MONTH_IN_YEAR";
    ColumnDataTypeEnum["DateNumQuarterInYear"] = "DATE_NUM_QUARTER_IN_YEAR";
    ColumnDataTypeEnum["DateNumSecInDay"] = "DATE_NUM_SEC_IN_DAY";
    ColumnDataTypeEnum["DateNumWeekInMonth"] = "DATE_NUM_WEEK_IN_MONTH";
    ColumnDataTypeEnum["DateNumWeekInQuarter"] = "DATE_NUM_WEEK_IN_QUARTER";
    ColumnDataTypeEnum["DateNumWeekInYear"] = "DATE_NUM_WEEK_IN_YEAR";
    ColumnDataTypeEnum["DateTime"] = "DATE_TIME";
    ColumnDataTypeEnum["Double"] = "DOUBLE";
    ColumnDataTypeEnum["Float"] = "FLOAT";
    ColumnDataTypeEnum["Int32"] = "INT32";
    ColumnDataTypeEnum["Int64"] = "INT64";
    ColumnDataTypeEnum["List"] = "LIST";
    ColumnDataTypeEnum["ListBool"] = "LIST_BOOL";
    ColumnDataTypeEnum["ListDate"] = "LIST_DATE";
    ColumnDataTypeEnum["ListDateTime"] = "LIST_DATE_TIME";
    ColumnDataTypeEnum["ListDouble"] = "LIST_DOUBLE";
    ColumnDataTypeEnum["ListInt"] = "LIST_INT";
    ColumnDataTypeEnum["ListString"] = "LIST_STRING";
    ColumnDataTypeEnum["ListTime"] = "LIST_TIME";
    ColumnDataTypeEnum["Time"] = "TIME";
    ColumnDataTypeEnum["Unknown"] = "UNKNOWN";
    ColumnDataTypeEnum["Varchar"] = "VARCHAR";
})(ColumnDataTypeEnum || (ColumnDataTypeEnum = {}));
export var ColumnProperty;
(function (ColumnProperty) {
    ColumnProperty["GrowthDimension"] = "GROWTH_DIMENSION";
    ColumnProperty["IsFormula"] = "IS_FORMULA";
    ColumnProperty["IsGrouping"] = "IS_GROUPING";
    ColumnProperty["IsOutput"] = "IS_OUTPUT";
    ColumnProperty["SortAscending"] = "SORT_ASCENDING";
    ColumnProperty["SortDescending"] = "SORT_DESCENDING";
})(ColumnProperty || (ColumnProperty = {}));
export var ColumnSortCategory;
(function (ColumnSortCategory) {
    ColumnSortCategory["Alpha"] = "ALPHA";
    ColumnSortCategory["Custom"] = "CUSTOM";
    ColumnSortCategory["Default"] = "DEFAULT";
    ColumnSortCategory["None"] = "NONE";
})(ColumnSortCategory || (ColumnSortCategory = {}));
export var ColumnSortConfigOptions;
(function (ColumnSortConfigOptions) {
    ColumnSortConfigOptions["Custom"] = "CUSTOM";
    ColumnSortConfigOptions["Default"] = "DEFAULT";
})(ColumnSortConfigOptions || (ColumnSortConfigOptions = {}));
export var ColumnTimeBucket;
(function (ColumnTimeBucket) {
    ColumnTimeBucket["Auto"] = "AUTO";
    ColumnTimeBucket["Daily"] = "DAILY";
    ColumnTimeBucket["DayOfMonth"] = "DAY_OF_MONTH";
    ColumnTimeBucket["DayOfQuarter"] = "DAY_OF_QUARTER";
    ColumnTimeBucket["DayOfWeek"] = "DAY_OF_WEEK";
    ColumnTimeBucket["DayOfYear"] = "DAY_OF_YEAR";
    ColumnTimeBucket["Hourly"] = "HOURLY";
    ColumnTimeBucket["HourOfDay"] = "HOUR_OF_DAY";
    ColumnTimeBucket["Monthly"] = "MONTHLY";
    ColumnTimeBucket["MonthOfQuarter"] = "MONTH_OF_QUARTER";
    ColumnTimeBucket["MonthOfYear"] = "MONTH_OF_YEAR";
    ColumnTimeBucket["NoBucket"] = "NO_BUCKET";
    ColumnTimeBucket["Quarterly"] = "QUARTERLY";
    ColumnTimeBucket["QuarterOfYear"] = "QUARTER_OF_YEAR";
    ColumnTimeBucket["Weekly"] = "WEEKLY";
    ColumnTimeBucket["WeekOfMonth"] = "WEEK_OF_MONTH";
    ColumnTimeBucket["WeekOfQuarter"] = "WEEK_OF_QUARTER";
    ColumnTimeBucket["WeekOfYear"] = "WEEK_OF_YEAR";
    ColumnTimeBucket["Yearly"] = "YEARLY";
})(ColumnTimeBucket || (ColumnTimeBucket = {}));
export var ColumnType;
(function (ColumnType) {
    ColumnType["Attribute"] = "ATTRIBUTE";
    ColumnType["Date"] = "DATE";
    ColumnType["Measure"] = "MEASURE";
})(ColumnType || (ColumnType = {}));
export var ColumnValueType;
(function (ColumnValueType) {
    ColumnValueType["Bool"] = "BOOL";
    ColumnValueType["Char"] = "CHAR";
    ColumnValueType["Date"] = "DATE";
    ColumnValueType["Double"] = "DOUBLE";
    ColumnValueType["Int"] = "INT";
    ColumnValueType["Unknown"] = "UNKNOWN";
})(ColumnValueType || (ColumnValueType = {}));
export var ComparisonOperatorType;
(function (ComparisonOperatorType) {
    ComparisonOperatorType["BeginsWith"] = "BEGINS_WITH";
    ComparisonOperatorType["Bw"] = "BW";
    ComparisonOperatorType["Contains"] = "CONTAINS";
    ComparisonOperatorType["EndsWith"] = "ENDS_WITH";
    ComparisonOperatorType["Eq"] = "EQ";
    ComparisonOperatorType["Ge"] = "GE";
    ComparisonOperatorType["Gt"] = "GT";
    ComparisonOperatorType["Le"] = "LE";
    ComparisonOperatorType["Lt"] = "LT";
    ComparisonOperatorType["Ne"] = "NE";
    ComparisonOperatorType["NotContains"] = "NOT_CONTAINS";
})(ComparisonOperatorType || (ComparisonOperatorType = {}));
export var ComparisonType;
(function (ComparisonType) {
    ComparisonType["Current"] = "CURRENT";
    ComparisonType["Previous"] = "PREVIOUS";
})(ComparisonType || (ComparisonType = {}));
export var ComponentType;
(function (ComponentType) {
    ComponentType["Group"] = "GROUP";
    ComponentType["Tile"] = "TILE";
})(ComponentType || (ComponentType = {}));
export var ConditionalFormattingComparisonTypes;
(function (ConditionalFormattingComparisonTypes) {
    ConditionalFormattingComparisonTypes["ColumnBased"] = "COLUMN_BASED";
    ConditionalFormattingComparisonTypes["ParameterBased"] = "PARAMETER_BASED";
    ConditionalFormattingComparisonTypes["ValueBased"] = "VALUE_BASED";
})(ConditionalFormattingComparisonTypes || (ConditionalFormattingComparisonTypes = {}));
export var ConnectionConfigType;
(function (ConnectionConfigType) {
    ConnectionConfigType["RdbmsAmazonAthena"] = "RDBMS_AMAZON_ATHENA";
    ConnectionConfigType["RdbmsAmazonAuroraMysql"] = "RDBMS_AMAZON_AURORA_MYSQL";
    ConnectionConfigType["RdbmsAmazonAuroraPostgresql"] = "RDBMS_AMAZON_AURORA_POSTGRESQL";
    ConnectionConfigType["RdbmsAmazonRdsMysql"] = "RDBMS_AMAZON_RDS_MYSQL";
    ConnectionConfigType["RdbmsAmazonRdsPostgresql"] = "RDBMS_AMAZON_RDS_POSTGRESQL";
    ConnectionConfigType["RdbmsAzureSqlDatawarehouse"] = "RDBMS_AZURE_SQL_DATAWAREHOUSE";
    ConnectionConfigType["RdbmsClickhouse"] = "RDBMS_CLICKHOUSE";
    ConnectionConfigType["RdbmsDatabricks"] = "RDBMS_DATABRICKS";
    ConnectionConfigType["RdbmsDenodo"] = "RDBMS_DENODO";
    ConnectionConfigType["RdbmsDremio"] = "RDBMS_DREMIO";
    ConnectionConfigType["RdbmsDrSum"] = "RDBMS_DR_SUM";
    ConnectionConfigType["RdbmsFalcon"] = "RDBMS_FALCON";
    ConnectionConfigType["RdbmsFalconOnprem"] = "RDBMS_FALCON_ONPREM";
    ConnectionConfigType["RdbmsGcpAlloydbPostgresql"] = "RDBMS_GCP_ALLOYDB_POSTGRESQL";
    ConnectionConfigType["RdbmsGcpBigquery"] = "RDBMS_GCP_BIGQUERY";
    ConnectionConfigType["RdbmsGcpMysql"] = "RDBMS_GCP_MYSQL";
    ConnectionConfigType["RdbmsGcpPostgresql"] = "RDBMS_GCP_POSTGRESQL";
    ConnectionConfigType["RdbmsGcpSqlserver"] = "RDBMS_GCP_SQLSERVER";
    ConnectionConfigType["RdbmsGenericJdbc"] = "RDBMS_GENERIC_JDBC";
    ConnectionConfigType["RdbmsGoogleSheets"] = "RDBMS_GOOGLE_SHEETS";
    ConnectionConfigType["RdbmsLooker"] = "RDBMS_LOOKER";
    ConnectionConfigType["RdbmsLookerMl"] = "RDBMS_LOOKER_ML";
    ConnectionConfigType["RdbmsMode"] = "RDBMS_MODE";
    ConnectionConfigType["RdbmsMysql"] = "RDBMS_MYSQL";
    ConnectionConfigType["RdbmsOracleAdw"] = "RDBMS_ORACLE_ADW";
    ConnectionConfigType["RdbmsPostgres"] = "RDBMS_POSTGRES";
    ConnectionConfigType["RdbmsPresto"] = "RDBMS_PRESTO";
    ConnectionConfigType["RdbmsPrestoJdbc"] = "RDBMS_PRESTO_JDBC";
    ConnectionConfigType["RdbmsRedshift"] = "RDBMS_REDSHIFT";
    ConnectionConfigType["RdbmsSapHana"] = "RDBMS_SAP_HANA";
    ConnectionConfigType["RdbmsSinglestore"] = "RDBMS_SINGLESTORE";
    ConnectionConfigType["RdbmsSnowflake"] = "RDBMS_SNOWFLAKE";
    ConnectionConfigType["RdbmsSqlserver"] = "RDBMS_SQLSERVER";
    ConnectionConfigType["RdbmsTeradata"] = "RDBMS_TERADATA";
    ConnectionConfigType["RdbmsTrino"] = "RDBMS_TRINO";
})(ConnectionConfigType || (ConnectionConfigType = {}));
export var ConnectionRelationType;
(function (ConnectionRelationType) {
    ConnectionRelationType["Administrator"] = "ADMINISTRATOR";
    ConnectionRelationType["ConnectionOwner"] = "CONNECTION_OWNER";
    ConnectionRelationType["None"] = "NONE";
    ConnectionRelationType["SharedWithCurrentUser"] = "SHARED_WITH_CURRENT_USER";
})(ConnectionRelationType || (ConnectionRelationType = {}));
export var ConnectionTypeEnum;
(function (ConnectionTypeEnum) {
    ConnectionTypeEnum["DataSource"] = "DATA_SOURCE";
    ConnectionTypeEnum["LogicalColumn"] = "LOGICAL_COLUMN";
    ConnectionTypeEnum["LogicalTable"] = "LOGICAL_TABLE";
})(ConnectionTypeEnum || (ConnectionTypeEnum = {}));
export var ConnectorType;
(function (ConnectorType) {
    ConnectorType["Airbyte"] = "AIRBYTE";
    ConnectorType["Fivetran"] = "FIVETRAN";
    ConnectorType["Matillion"] = "MATILLION";
})(ConnectorType || (ConnectorType = {}));
export var CortexInsightStatus;
(function (CortexInsightStatus) {
    CortexInsightStatus["CortexAnalysisFailed"] = "CORTEX_ANALYSIS_FAILED";
    CortexInsightStatus["StatusCodeOk"] = "STATUS_CODE_OK";
})(CortexInsightStatus || (CortexInsightStatus = {}));
export var CurrencyFormatType;
(function (CurrencyFormatType) {
    CurrencyFormatType["Column"] = "COLUMN";
    CurrencyFormatType["IsoCode"] = "ISO_CODE";
    CurrencyFormatType["UserLocale"] = "USER_LOCALE";
})(CurrencyFormatType || (CurrencyFormatType = {}));
export var CurrencySetting;
(function (CurrencySetting) {
    CurrencySetting["FromColumn"] = "FROM_COLUMN";
    CurrencySetting["FromIsoCode"] = "FROM_ISO_CODE";
    CurrencySetting["FromUserLocale"] = "FROM_USER_LOCALE";
    CurrencySetting["None"] = "NONE";
})(CurrencySetting || (CurrencySetting = {}));
export var CurrentDataOptionsEnum;
(function (CurrentDataOptionsEnum) {
    CurrentDataOptionsEnum["CurrentOnly"] = "CURRENT_ONLY";
    CurrentDataOptionsEnum["Exclude"] = "EXCLUDE";
    CurrentDataOptionsEnum["Include"] = "INCLUDE";
})(CurrentDataOptionsEnum || (CurrentDataOptionsEnum = {}));
export var CustomChartAxisConfigTypeEnum;
(function (CustomChartAxisConfigTypeEnum) {
    CustomChartAxisConfigTypeEnum["Dual"] = "DUAL";
    CustomChartAxisConfigTypeEnum["Flat"] = "FLAT";
    CustomChartAxisConfigTypeEnum["Merged"] = "MERGED";
})(CustomChartAxisConfigTypeEnum || (CustomChartAxisConfigTypeEnum = {}));
export var CustomChartDimensionModeEnum;
(function (CustomChartDimensionModeEnum) {
    CustomChartDimensionModeEnum["AxisDriven"] = "AXIS_DRIVEN";
    CustomChartDimensionModeEnum["ColumnDriven"] = "COLUMN_DRIVEN";
})(CustomChartDimensionModeEnum || (CustomChartDimensionModeEnum = {}));
export var DataConnection;
(function (DataConnection) {
    DataConnection["AmazonRedshift"] = "AMAZON_REDSHIFT";
    DataConnection["AzureSynapse"] = "AZURE_SYNAPSE";
    DataConnection["Databricks"] = "DATABRICKS";
    DataConnection["Denodo"] = "DENODO";
    DataConnection["Dremio"] = "DREMIO";
    DataConnection["GoogleBigquery"] = "GOOGLE_BIGQUERY";
    DataConnection["OracleAdw"] = "ORACLE_ADW";
    DataConnection["SapHana"] = "SAP_HANA";
    DataConnection["Snowflake"] = "SNOWFLAKE";
    DataConnection["Starburst"] = "STARBURST";
    DataConnection["Teradata"] = "TERADATA";
})(DataConnection || (DataConnection = {}));
export var DataSourceOrigin;
(function (DataSourceOrigin) {
    DataSourceOrigin["Copilot"] = "COPILOT";
    DataSourceOrigin["Nls"] = "NLS";
    DataSourceOrigin["TrainSage"] = "TRAIN_SAGE";
    DataSourceOrigin["UnifiedSage"] = "UNIFIED_SAGE";
})(DataSourceOrigin || (DataSourceOrigin = {}));
export var DataSourceType;
(function (DataSourceType) {
    DataSourceType["Default"] = "DEFAULT";
    DataSourceType["FileCsv"] = "FILE_CSV";
    DataSourceType["Informatica"] = "INFORMATICA";
    DataSourceType["IpaasInformatica"] = "IPAAS_INFORMATICA";
    DataSourceType["RdbmsAmazonAthena"] = "RDBMS_AMAZON_ATHENA";
    DataSourceType["RdbmsAmazonAuroraMysql"] = "RDBMS_AMAZON_AURORA_MYSQL";
    DataSourceType["RdbmsAmazonAuroraPostgresql"] = "RDBMS_AMAZON_AURORA_POSTGRESQL";
    DataSourceType["RdbmsAmazonRdsMysql"] = "RDBMS_AMAZON_RDS_MYSQL";
    DataSourceType["RdbmsAmazonRdsPostgresql"] = "RDBMS_AMAZON_RDS_POSTGRESQL";
    DataSourceType["RdbmsAzureSqlDatawarehouse"] = "RDBMS_AZURE_SQL_DATAWAREHOUSE";
    DataSourceType["RdbmsClickhouse"] = "RDBMS_CLICKHOUSE";
    DataSourceType["RdbmsDatabricks"] = "RDBMS_DATABRICKS";
    DataSourceType["RdbmsDenodo"] = "RDBMS_DENODO";
    DataSourceType["RdbmsDremio"] = "RDBMS_DREMIO";
    DataSourceType["RdbmsDrSum"] = "RDBMS_DR_SUM";
    DataSourceType["RdbmsFalcon"] = "RDBMS_FALCON";
    DataSourceType["RdbmsFalconOnprem"] = "RDBMS_FALCON_ONPREM";
    DataSourceType["RdbmsGcpAlloydbPostgresql"] = "RDBMS_GCP_ALLOYDB_POSTGRESQL";
    DataSourceType["RdbmsGcpBigquery"] = "RDBMS_GCP_BIGQUERY";
    DataSourceType["RdbmsGcpMysql"] = "RDBMS_GCP_MYSQL";
    DataSourceType["RdbmsGcpPostgresql"] = "RDBMS_GCP_POSTGRESQL";
    DataSourceType["RdbmsGcpSqlserver"] = "RDBMS_GCP_SQLSERVER";
    DataSourceType["RdbmsGenericJdbc"] = "RDBMS_GENERIC_JDBC";
    DataSourceType["RdbmsGoogleSheets"] = "RDBMS_GOOGLE_SHEETS";
    DataSourceType["RdbmsLooker"] = "RDBMS_LOOKER";
    DataSourceType["RdbmsLookerMl"] = "RDBMS_LOOKER_ML";
    DataSourceType["RdbmsMarketo"] = "RDBMS_MARKETO";
    DataSourceType["RdbmsMockDatabase"] = "RDBMS_MOCK_DATABASE";
    DataSourceType["RdbmsMode"] = "RDBMS_MODE";
    DataSourceType["RdbmsMysql"] = "RDBMS_MYSQL";
    DataSourceType["RdbmsOracle"] = "RDBMS_ORACLE";
    DataSourceType["RdbmsOracleAdw"] = "RDBMS_ORACLE_ADW";
    DataSourceType["RdbmsPostgres"] = "RDBMS_POSTGRES";
    DataSourceType["RdbmsPresto"] = "RDBMS_PRESTO";
    DataSourceType["RdbmsPrestoJdbc"] = "RDBMS_PRESTO_JDBC";
    DataSourceType["RdbmsRedshift"] = "RDBMS_REDSHIFT";
    DataSourceType["RdbmsSalesforce"] = "RDBMS_SALESFORCE";
    DataSourceType["RdbmsSapHana"] = "RDBMS_SAP_HANA";
    DataSourceType["RdbmsServiceNow"] = "RDBMS_SERVICE_NOW";
    DataSourceType["RdbmsSinglestore"] = "RDBMS_SINGLESTORE";
    DataSourceType["RdbmsSnowflake"] = "RDBMS_SNOWFLAKE";
    DataSourceType["RdbmsSqlserver"] = "RDBMS_SQLSERVER";
    DataSourceType["RdbmsTeradata"] = "RDBMS_TERADATA";
    DataSourceType["RdbmsTrino"] = "RDBMS_TRINO";
    DataSourceType["SaasSalesforce"] = "SAAS_SALESFORCE";
})(DataSourceType || (DataSourceType = {}));
export var DateFilterType;
(function (DateFilterType) {
    DateFilterType["ExactDate"] = "EXACT_DATE";
    DateFilterType["ExactDateRange"] = "EXACT_DATE_RANGE";
    DateFilterType["ExactDateTime"] = "EXACT_DATE_TIME";
    DateFilterType["ExactTime"] = "EXACT_TIME";
    DateFilterType["LastNPeriod"] = "LAST_N_PERIOD";
    DateFilterType["LastPeriod"] = "LAST_PERIOD";
    DateFilterType["MonthOnly"] = "MONTH_ONLY";
    DateFilterType["MonthYear"] = "MONTH_YEAR";
    DateFilterType["NextNPeriod"] = "NEXT_N_PERIOD";
    DateFilterType["NextPeriod"] = "NEXT_PERIOD";
    DateFilterType["Now"] = "NOW";
    DateFilterType["NumDateFilters"] = "NUM_DATE_FILTERS";
    DateFilterType["NPeriodAgo"] = "N_PERIOD_AGO";
    DateFilterType["PeriodOnly"] = "PERIOD_ONLY";
    DateFilterType["PeriodToDate"] = "PERIOD_TO_DATE";
    DateFilterType["QuarterOnly"] = "QUARTER_ONLY";
    DateFilterType["QuarterYear"] = "QUARTER_YEAR";
    DateFilterType["ThisPeriod"] = "THIS_PERIOD";
    DateFilterType["Today"] = "TODAY";
    DateFilterType["Tomorrow"] = "TOMORROW";
    DateFilterType["WeekdayOnly"] = "WEEKDAY_ONLY";
    DateFilterType["YearOnly"] = "YEAR_ONLY";
    DateFilterType["Yesterday"] = "YESTERDAY";
})(DateFilterType || (DateFilterType = {}));
export var DatePeriod;
(function (DatePeriod) {
    DatePeriod["Day"] = "DAY";
    DatePeriod["Hour"] = "HOUR";
    DatePeriod["Minute"] = "MINUTE";
    DatePeriod["Month"] = "MONTH";
    DatePeriod["NumDatePeriods"] = "NUM_DATE_PERIODS";
    DatePeriod["Quarter"] = "QUARTER";
    DatePeriod["Second"] = "SECOND";
    DatePeriod["Week"] = "WEEK";
    DatePeriod["Year"] = "YEAR";
})(DatePeriod || (DatePeriod = {}));
export var DependencyListObjectType;
(function (DependencyListObjectType) {
    DependencyListObjectType["CustomChartConfigManifest"] = "CUSTOM_CHART_CONFIG_MANIFEST";
    DependencyListObjectType["DataSource"] = "DATA_SOURCE";
    DependencyListObjectType["File"] = "FILE";
    DependencyListObjectType["LogicalColumn"] = "LOGICAL_COLUMN";
    DependencyListObjectType["LogicalRelationship"] = "LOGICAL_RELATIONSHIP";
    DependencyListObjectType["LogicalTable"] = "LOGICAL_TABLE";
    DependencyListObjectType["PinboardAnswerBook"] = "PINBOARD_ANSWER_BOOK";
    DependencyListObjectType["PinboardAnswerSheet"] = "PINBOARD_ANSWER_SHEET";
    DependencyListObjectType["QuestionAnswerBook"] = "QUESTION_ANSWER_BOOK";
    DependencyListObjectType["QuestionAnswerSheet"] = "QUESTION_ANSWER_SHEET";
    DependencyListObjectType["RTemplate"] = "R_TEMPLATE";
    DependencyListObjectType["Tag"] = "TAG";
    DependencyListObjectType["User"] = "USER";
    DependencyListObjectType["UserGroup"] = "USER_GROUP";
})(DependencyListObjectType || (DependencyListObjectType = {}));
export var DependentObjectVersion;
(function (DependentObjectVersion) {
    DependentObjectVersion["V1"] = "V1";
    DependentObjectVersion["V2"] = "V2";
})(DependentObjectVersion || (DependentObjectVersion = {}));
export var DestinationOperationTypes;
(function (DestinationOperationTypes) {
    DestinationOperationTypes["Archive"] = "ARCHIVE";
    DestinationOperationTypes["Create"] = "CREATE";
    DestinationOperationTypes["Delete"] = "DELETE";
    DestinationOperationTypes["Insert"] = "INSERT";
    DestinationOperationTypes["Update"] = "UPDATE";
    DestinationOperationTypes["Upsert"] = "UPSERT";
})(DestinationOperationTypes || (DestinationOperationTypes = {}));
export var DestinationTypes;
(function (DestinationTypes) {
    DestinationTypes["Bigquery"] = "BIGQUERY";
    DestinationTypes["Gainsight"] = "GAINSIGHT";
    DestinationTypes["Googlesheets"] = "GOOGLESHEETS";
    DestinationTypes["Hubspot"] = "HUBSPOT";
    DestinationTypes["Mailchimp"] = "MAILCHIMP";
    DestinationTypes["Msexcel"] = "MSEXCEL";
    DestinationTypes["Msteams"] = "MSTEAMS";
    DestinationTypes["Redshift"] = "REDSHIFT";
    DestinationTypes["Salesforce"] = "SALESFORCE";
    DestinationTypes["Servicenow"] = "SERVICENOW";
    DestinationTypes["Slack"] = "SLACK";
    DestinationTypes["Snowflake"] = "SNOWFLAKE";
    DestinationTypes["Webex"] = "WEBEX";
    DestinationTypes["Zendesk"] = "ZENDESK";
    DestinationTypes["Zoho"] = "ZOHO";
})(DestinationTypes || (DestinationTypes = {}));
export var DisallowedAlertTypeErrorCode;
(function (DisallowedAlertTypeErrorCode) {
    DisallowedAlertTypeErrorCode["AlertAcrossAttributesFlagDisabled"] = "ALERT_ACROSS_ATTRIBUTES_FLAG_DISABLED";
    DisallowedAlertTypeErrorCode["AnomalyDisabledAtChartLevel"] = "ANOMALY_DISABLED_AT_CHART_LEVEL";
    DisallowedAlertTypeErrorCode["AnomalyDisabledAtUserProfile"] = "ANOMALY_DISABLED_AT_USER_PROFILE";
    DisallowedAlertTypeErrorCode["AnomalyDisabledChartNonTimeSeries"] = "ANOMALY_DISABLED_CHART_NON_TIME_SERIES";
    DisallowedAlertTypeErrorCode["AnomalyDisabledFalconSource"] = "ANOMALY_DISABLED_FALCON_SOURCE";
    DisallowedAlertTypeErrorCode["AnomalyFlagDisabled"] = "ANOMALY_FLAG_DISABLED";
    DisallowedAlertTypeErrorCode["GrowthKeywordNotSupported"] = "GROWTH_KEYWORD_NOT_SUPPORTED";
    DisallowedAlertTypeErrorCode["GrowthOfKeywordNotSupported"] = "GROWTH_OF_KEYWORD_NOT_SUPPORTED";
    DisallowedAlertTypeErrorCode["HourlyKpiNotSupported"] = "HOURLY_KPI_NOT_SUPPORTED";
    DisallowedAlertTypeErrorCode["OfKeywordNotSupported"] = "OF_KEYWORD_NOT_SUPPORTED";
    DisallowedAlertTypeErrorCode["PercentageOfKeywordNotSupported"] = "PERCENTAGE_OF_KEYWORD_NOT_SUPPORTED";
    DisallowedAlertTypeErrorCode["UnexpectedError"] = "UNEXPECTED_ERROR";
    DisallowedAlertTypeErrorCode["UnsupportedFormula"] = "UNSUPPORTED_FORMULA";
    DisallowedAlertTypeErrorCode["VersusKeywordNotSupported"] = "VERSUS_KEYWORD_NOT_SUPPORTED";
})(DisallowedAlertTypeErrorCode || (DisallowedAlertTypeErrorCode = {}));
export var DisplayMode;
(function (DisplayMode) {
    DisplayMode["ChartMode"] = "CHART_MODE";
    DisplayMode["HeadlineMode"] = "HEADLINE_MODE";
    DisplayMode["RAnalysisMode"] = "R_ANALYSIS_MODE";
    DisplayMode["TableMode"] = "TABLE_MODE";
    DisplayMode["Undefined"] = "UNDEFINED";
})(DisplayMode || (DisplayMode = {}));
export var EDocFormatType;
(function (EDocFormatType) {
    EDocFormatType["Json"] = "JSON";
    EDocFormatType["Proto"] = "PROTO";
    EDocFormatType["Yaml"] = "YAML";
})(EDocFormatType || (EDocFormatType = {}));
export var EDocGenerationType;
(function (EDocGenerationType) {
    EDocGenerationType["Autogenerated"] = "AUTOGENERATED";
    EDocGenerationType["Default"] = "DEFAULT";
})(EDocGenerationType || (EDocGenerationType = {}));
export var EditType;
(function (EditType) {
    EditType["Editable"] = "EDITABLE";
    EditType["Hidden"] = "HIDDEN";
    EditType["MultiSelection"] = "MULTI_SELECTION";
    EditType["NonEditable"] = "NON_EDITABLE";
    EditType["Text"] = "TEXT";
})(EditType || (EditType = {}));
export var EmptyAnswerStateEnum;
(function (EmptyAnswerStateEnum) {
    EmptyAnswerStateEnum["AutogenAnswer"] = "AUTOGEN_ANSWER";
    EmptyAnswerStateEnum["Default"] = "DEFAULT";
    EmptyAnswerStateEnum["StartAaq"] = "START_AAQ";
    EmptyAnswerStateEnum["StartSearchAssist"] = "START_SEARCH_ASSIST";
})(EmptyAnswerStateEnum || (EmptyAnswerStateEnum = {}));
export var EventSchemaType;
(function (EventSchemaType) {
    EventSchemaType["Monitor"] = "MONITOR";
})(EventSchemaType || (EventSchemaType = {}));
export var ExplorationType;
(function (ExplorationType) {
    ExplorationType["Add"] = "ADD";
    ExplorationType["Compare"] = "COMPARE";
    ExplorationType["Filter"] = "FILTER";
    ExplorationType["Replace"] = "REPLACE";
})(ExplorationType || (ExplorationType = {}));
export var FalconDataType;
(function (FalconDataType) {
    FalconDataType["Bool"] = "BOOL";
    FalconDataType["ByteArray"] = "BYTE_ARRAY";
    FalconDataType["Char"] = "CHAR";
    FalconDataType["Date"] = "DATE";
    FalconDataType["DateTime"] = "DATE_TIME";
    FalconDataType["Double"] = "DOUBLE";
    FalconDataType["Float"] = "FLOAT";
    FalconDataType["Int32"] = "INT32";
    FalconDataType["Int64"] = "INT64";
    FalconDataType["List"] = "LIST";
    FalconDataType["ListBool"] = "LIST_BOOL";
    FalconDataType["ListDate"] = "LIST_DATE";
    FalconDataType["ListDateTime"] = "LIST_DATE_TIME";
    FalconDataType["ListDouble"] = "LIST_DOUBLE";
    FalconDataType["ListInt"] = "LIST_INT";
    FalconDataType["ListString"] = "LIST_STRING";
    FalconDataType["ListTime"] = "LIST_TIME";
    FalconDataType["MaxType"] = "MAX_TYPE";
    FalconDataType["Time"] = "TIME";
    FalconDataType["Unknown"] = "UNKNOWN";
})(FalconDataType || (FalconDataType = {}));
export var FalconValueTypeEnum;
(function (FalconValueTypeEnum) {
    FalconValueTypeEnum["TypeBool"] = "TYPE_BOOL";
    FalconValueTypeEnum["TypeDouble"] = "TYPE_DOUBLE";
    FalconValueTypeEnum["TypeInt64"] = "TYPE_INT64";
    FalconValueTypeEnum["TypeNull"] = "TYPE_NULL";
    FalconValueTypeEnum["TypeString"] = "TYPE_STRING";
    FalconValueTypeEnum["TypeStringCase"] = "TYPE_STRING_CASE";
})(FalconValueTypeEnum || (FalconValueTypeEnum = {}));
export var FeedbackReason;
(function (FeedbackReason) {
    FeedbackReason["NotInterested"] = "NOT_INTERESTED";
    FeedbackReason["QuestionAnswerMismatch"] = "QUESTION_ANSWER_MISMATCH";
})(FeedbackReason || (FeedbackReason = {}));
export var FeedbackType;
(function (FeedbackType) {
    FeedbackType["AllAnomaliesObvious"] = "ALL_ANOMALIES_OBVIOUS";
    FeedbackType["AllChangesExpected"] = "ALL_CHANGES_EXPECTED";
    FeedbackType["AnomalousPointUninteresting"] = "ANOMALOUS_POINT_UNINTERESTING";
    FeedbackType["AttributeColumnUninteresting"] = "ATTRIBUTE_COLUMN_UNINTERESTING";
    FeedbackType["AttributeFilterCombinationUninteresting"] = "ATTRIBUTE_FILTER_COMBINATION_UNINTERESTING";
    FeedbackType["BetterDateBucket"] = "BETTER_DATE_BUCKET";
    FeedbackType["CorrelationObvious"] = "CORRELATION_OBVIOUS";
    FeedbackType["DataSourceUninteresting"] = "DATA_SOURCE_UNINTERESTING";
    FeedbackType["DiffExpected"] = "DIFF_EXPECTED";
    FeedbackType["DiffValueUninteresting"] = "DIFF_VALUE_UNINTERESTING";
    FeedbackType["FilterColumnUninteresting"] = "FILTER_COLUMN_UNINTERESTING";
    FeedbackType["MeasureColumnUninteresting"] = "MEASURE_COLUMN_UNINTERESTING";
    FeedbackType["MeasureFilterCombinationObvious"] = "MEASURE_FILTER_COMBINATION_OBVIOUS";
    FeedbackType["TrendBetterDateAttribute"] = "TREND_BETTER_DATE_ATTRIBUTE";
    FeedbackType["TrendObvious"] = "TREND_OBVIOUS";
})(FeedbackType || (FeedbackType = {}));
export var FilterProperty;
(function (FilterProperty) {
    FilterProperty["IncludeNull"] = "INCLUDE_NULL";
    FilterProperty["IsDateFilter"] = "IS_DATE_FILTER";
    FilterProperty["IsFormula"] = "IS_FORMULA";
    FilterProperty["IsInSubquery"] = "IS_IN_SUBQUERY";
})(FilterProperty || (FilterProperty = {}));
export var FilterTypes;
(function (FilterTypes) {
    FilterTypes["BeginsWith"] = "BEGINS_WITH";
    FilterTypes["Bw"] = "BW";
    FilterTypes["BwInc"] = "BW_INC";
    FilterTypes["BwIncMax"] = "BW_INC_MAX";
    FilterTypes["BwIncMin"] = "BW_INC_MIN";
    FilterTypes["Contains"] = "CONTAINS";
    FilterTypes["EndsWith"] = "ENDS_WITH";
    FilterTypes["Eq"] = "EQ";
    FilterTypes["Ge"] = "GE";
    FilterTypes["Gt"] = "GT";
    FilterTypes["In"] = "IN";
    FilterTypes["Le"] = "LE";
    FilterTypes["Like"] = "LIKE";
    FilterTypes["Lt"] = "LT";
    FilterTypes["Ne"] = "NE";
    FilterTypes["NotIn"] = "NOT_IN";
})(FilterTypes || (FilterTypes = {}));
export var FilterValueDataType;
(function (FilterValueDataType) {
    FilterValueDataType["Bool"] = "BOOL";
    FilterValueDataType["Char"] = "CHAR";
    FilterValueDataType["Date"] = "DATE";
    FilterValueDataType["Double"] = "DOUBLE";
    FilterValueDataType["Int"] = "INT";
    FilterValueDataType["Unknown"] = "UNKNOWN";
})(FilterValueDataType || (FilterValueDataType = {}));
export var FilterValueType;
(function (FilterValueType) {
    FilterValueType["DateFilter"] = "DATE_FILTER";
    FilterValueType["String"] = "STRING";
})(FilterValueType || (FilterValueType = {}));
export var FormatData;
(function (FormatData) {
    FormatData["Compact"] = "COMPACT";
    FormatData["Full"] = "FULL";
})(FormatData || (FormatData = {}));
export var FormatType;
(function (FormatType) {
    FormatType["Json"] = "JSON";
    FormatType["Yaml"] = "YAML";
})(FormatType || (FormatType = {}));
export var FrequencyGranularity;
(function (FrequencyGranularity) {
    FrequencyGranularity["Daily"] = "DAILY";
    FrequencyGranularity["EveryMinute"] = "EVERY_MINUTE";
    FrequencyGranularity["Hourly"] = "HOURLY";
    FrequencyGranularity["Monthly"] = "MONTHLY";
    FrequencyGranularity["Weekly"] = "WEEKLY";
})(FrequencyGranularity || (FrequencyGranularity = {}));
export var GeoConfigGeometryTypes;
(function (GeoConfigGeometryTypes) {
    GeoConfigGeometryTypes["Circle"] = "CIRCLE";
    GeoConfigGeometryTypes["GeometryCollection"] = "GEOMETRY_COLLECTION";
    GeoConfigGeometryTypes["LinearRing"] = "LINEAR_RING";
    GeoConfigGeometryTypes["LineString"] = "LINE_STRING";
    GeoConfigGeometryTypes["MultiLineString"] = "MULTI_LINE_STRING";
    GeoConfigGeometryTypes["MultiPoint"] = "MULTI_POINT";
    GeoConfigGeometryTypes["MultiPolygon"] = "MULTI_POLYGON";
    GeoConfigGeometryTypes["Point"] = "POINT";
    GeoConfigGeometryTypes["Polygon"] = "POLYGON";
})(GeoConfigGeometryTypes || (GeoConfigGeometryTypes = {}));
export var GeoConfigType;
(function (GeoConfigType) {
    GeoConfigType["AdminDiv_0"] = "ADMIN_DIV_0";
    GeoConfigType["AdminDiv_1"] = "ADMIN_DIV_1";
    GeoConfigType["AdminDiv_2"] = "ADMIN_DIV_2";
    GeoConfigType["CustomRegion"] = "CUSTOM_REGION";
    GeoConfigType["Latitude"] = "LATITUDE";
    GeoConfigType["Longitude"] = "LONGITUDE";
    GeoConfigType["ZipCode"] = "ZIP_CODE";
})(GeoConfigType || (GeoConfigType = {}));
export var GeoConfigTypes;
(function (GeoConfigTypes) {
    GeoConfigTypes["AdminDiv_0"] = "ADMIN_DIV_0";
    GeoConfigTypes["AdminDiv_1"] = "ADMIN_DIV_1";
    GeoConfigTypes["AdminDiv_2"] = "ADMIN_DIV_2";
    GeoConfigTypes["CustomRegion"] = "CUSTOM_REGION";
    GeoConfigTypes["Latitude"] = "LATITUDE";
    GeoConfigTypes["Longitude"] = "LONGITUDE";
    GeoConfigTypes["None"] = "NONE";
    GeoConfigTypes["ZipCode"] = "ZIP_CODE";
})(GeoConfigTypes || (GeoConfigTypes = {}));
export var GeometryType;
(function (GeometryType) {
    GeometryType["Circle"] = "CIRCLE";
    GeometryType["GeometryCollection"] = "GEOMETRY_COLLECTION";
    GeometryType["LinearRing"] = "LINEAR_RING";
    GeometryType["LineString"] = "LINE_STRING";
    GeometryType["MultiLineString"] = "MULTI_LINE_STRING";
    GeometryType["MultiPoint"] = "MULTI_POINT";
    GeometryType["MultiPolygon"] = "MULTI_POLYGON";
    GeometryType["Point"] = "POINT";
    GeometryType["Polygon"] = "POLYGON";
})(GeometryType || (GeometryType = {}));
export var GitConfigsMappingStatus;
(function (GitConfigsMappingStatus) {
    GitConfigsMappingStatus["Mapped"] = "MAPPED";
    GitConfigsMappingStatus["Unmapped"] = "UNMAPPED";
})(GitConfigsMappingStatus || (GitConfigsMappingStatus = {}));
export var GitConfigsSortFieldName;
(function (GitConfigsSortFieldName) {
    GitConfigsSortFieldName["Name"] = "NAME";
    GitConfigsSortFieldName["Status"] = "STATUS";
})(GitConfigsSortFieldName || (GitConfigsSortFieldName = {}));
export var GitConfigsSortOrder;
(function (GitConfigsSortOrder) {
    GitConfigsSortOrder["Asc"] = "ASC";
    GitConfigsSortOrder["Desc"] = "DESC";
})(GitConfigsSortOrder || (GitConfigsSortOrder = {}));
export var GroupBrandColor;
(function (GroupBrandColor) {
    GroupBrandColor["GbcA"] = "GBC_A";
    GroupBrandColor["GbcB"] = "GBC_B";
    GroupBrandColor["GbcC"] = "GBC_C";
    GroupBrandColor["GbcD"] = "GBC_D";
    GroupBrandColor["GbcE"] = "GBC_E";
    GroupBrandColor["GbcF"] = "GBC_F";
    GroupBrandColor["GbcG"] = "GBC_G";
    GroupBrandColor["GbcH"] = "GBC_H";
    GroupBrandColor["GbcUnknown"] = "GBC_UNKNOWN";
})(GroupBrandColor || (GroupBrandColor = {}));
export var GroupColorShade;
(function (GroupColorShade) {
    GroupColorShade["GcsA"] = "GCS_A";
    GroupColorShade["GcsUnknown"] = "GCS_UNKNOWN";
})(GroupColorShade || (GroupColorShade = {}));
export var GroupOperationType;
(function (GroupOperationType) {
    GroupOperationType["Add"] = "ADD";
    GroupOperationType["Overwrite"] = "OVERWRITE";
    GroupOperationType["Remove"] = "REMOVE";
})(GroupOperationType || (GroupOperationType = {}));
export var Groups__GroupType;
(function (Groups__GroupType) {
    Groups__GroupType["LdapGroup"] = "LDAP_GROUP";
    Groups__GroupType["LocalGroup"] = "LOCAL_GROUP";
    Groups__GroupType["TeamGroup"] = "TEAM_GROUP";
    Groups__GroupType["TenantGroup"] = "TENANT_GROUP";
})(Groups__GroupType || (Groups__GroupType = {}));
export var Groups__ParentType;
(function (Groups__ParentType) {
    Groups__ParentType["Group"] = "GROUP";
    Groups__ParentType["User"] = "USER";
})(Groups__ParentType || (Groups__ParentType = {}));
export var HandleMissingValues;
(function (HandleMissingValues) {
    HandleMissingValues["DontShow"] = "DONT_SHOW";
    HandleMissingValues["ShowAsZero"] = "SHOW_AS_ZERO";
    HandleMissingValues["ShowGap"] = "SHOW_GAP";
})(HandleMissingValues || (HandleMissingValues = {}));
export var HeadlineVizPropVersion;
(function (HeadlineVizPropVersion) {
    HeadlineVizPropVersion["PreV1"] = "PRE_V1";
    HeadlineVizPropVersion["V1"] = "V1";
})(HeadlineVizPropVersion || (HeadlineVizPropVersion = {}));
export var HomepageModule;
(function (HomepageModule) {
    HomepageModule["Favorite"] = "FAVORITE";
    HomepageModule["Learning"] = "LEARNING";
    HomepageModule["MyLibrary"] = "MY_LIBRARY";
    HomepageModule["Search"] = "SEARCH";
    HomepageModule["Trending"] = "TRENDING";
    HomepageModule["Watchlist"] = "WATCHLIST";
})(HomepageModule || (HomepageModule = {}));
export var HomepageModuleConfigLevel;
(function (HomepageModuleConfigLevel) {
    HomepageModuleConfigLevel["Cluster"] = "CLUSTER";
    HomepageModuleConfigLevel["Org"] = "ORG";
    HomepageModuleConfigLevel["User"] = "USER";
})(HomepageModuleConfigLevel || (HomepageModuleConfigLevel = {}));
export var ImportEPackAction;
(function (ImportEPackAction) {
    ImportEPackAction["Create"] = "CREATE";
    ImportEPackAction["Update"] = "UPDATE";
    ImportEPackAction["UpdateOrCreate"] = "UPDATE_OR_CREATE";
})(ImportEPackAction || (ImportEPackAction = {}));
export var ImportEPackPolicy;
(function (ImportEPackPolicy) {
    ImportEPackPolicy["AllOrNone"] = "ALL_OR_NONE";
    ImportEPackPolicy["Partial"] = "PARTIAL";
    ImportEPackPolicy["PartialObject"] = "PARTIAL_OBJECT";
    ImportEPackPolicy["ValidateOnly"] = "VALIDATE_ONLY";
})(ImportEPackPolicy || (ImportEPackPolicy = {}));
export var ImportPolicy;
(function (ImportPolicy) {
    ImportPolicy["AllOrNone"] = "ALL_OR_NONE";
    ImportPolicy["Partial"] = "PARTIAL";
    ImportPolicy["PartialObject"] = "PARTIAL_OBJECT";
    ImportPolicy["ValidateOnly"] = "VALIDATE_ONLY";
})(ImportPolicy || (ImportPolicy = {}));
export var InferenceStatusEnum;
(function (InferenceStatusEnum) {
    InferenceStatusEnum["Done"] = "DONE";
    InferenceStatusEnum["Error"] = "ERROR";
    InferenceStatusEnum["Pending"] = "PENDING";
})(InferenceStatusEnum || (InferenceStatusEnum = {}));
export var IntegrationActionEnum;
(function (IntegrationActionEnum) {
    IntegrationActionEnum["Create"] = "CREATE";
    IntegrationActionEnum["Delete"] = "DELETE";
    IntegrationActionEnum["Edit"] = "EDIT";
})(IntegrationActionEnum || (IntegrationActionEnum = {}));
export var JobStatusEnum;
(function (JobStatusEnum) {
    JobStatusEnum["Cleanup"] = "CLEANUP";
    JobStatusEnum["Default"] = "DEFAULT";
    JobStatusEnum["Expired"] = "EXPIRED";
    JobStatusEnum["Paused"] = "PAUSED";
    JobStatusEnum["Scheduled"] = "SCHEDULED";
    JobStatusEnum["Stopped"] = "STOPPED";
})(JobStatusEnum || (JobStatusEnum = {}));
export var JoinType;
(function (JoinType) {
    JoinType["Cross"] = "CROSS";
    JoinType["FullOuter"] = "FULL_OUTER";
    JoinType["Inner"] = "INNER";
    JoinType["LeftOuter"] = "LEFT_OUTER";
    JoinType["RightOuter"] = "RIGHT_OUTER";
})(JoinType || (JoinType = {}));
export var KpiHeroFontSizeType;
(function (KpiHeroFontSizeType) {
    KpiHeroFontSizeType["L"] = "L";
    KpiHeroFontSizeType["M"] = "M";
    KpiHeroFontSizeType["S"] = "S";
    KpiHeroFontSizeType["Xl"] = "XL";
    KpiHeroFontSizeType["Xs"] = "XS";
})(KpiHeroFontSizeType || (KpiHeroFontSizeType = {}));
export var LayoutType;
(function (LayoutType) {
    LayoutType["Pinboard"] = "PINBOARD";
    LayoutType["Visualization"] = "VISUALIZATION";
})(LayoutType || (LayoutType = {}));
export var LegendPositionOptions;
(function (LegendPositionOptions) {
    LegendPositionOptions["BottomLegend"] = "BOTTOM_LEGEND";
    LegendPositionOptions["LeftLegend"] = "LEFT_LEGEND";
    LegendPositionOptions["RightLegend"] = "RIGHT_LEGEND";
    LegendPositionOptions["TopLegend"] = "TOP_LEGEND";
})(LegendPositionOptions || (LegendPositionOptions = {}));
export var LessonAdviceType;
(function (LessonAdviceType) {
    LessonAdviceType["AttributeColumn"] = "ATTRIBUTE_COLUMN";
    LessonAdviceType["ColumnOpFilter"] = "COLUMN_OP_FILTER";
    LessonAdviceType["CustomCalendar"] = "CUSTOM_CALENDAR";
    LessonAdviceType["Done"] = "DONE";
    LessonAdviceType["ErrorRemove"] = "ERROR_REMOVE";
    LessonAdviceType["ForEach"] = "FOR_EACH";
    LessonAdviceType["Geofilter"] = "GEOFILTER";
    LessonAdviceType["GrowthOf"] = "GROWTH_OF";
    LessonAdviceType["Having"] = "HAVING";
    LessonAdviceType["InitialAttribute"] = "INITIAL_ATTRIBUTE";
    LessonAdviceType["InitialMeasure"] = "INITIAL_MEASURE";
    LessonAdviceType["InFilter"] = "IN_FILTER";
    LessonAdviceType["LessonNotPossible"] = "LESSON_NOT_POSSIBLE";
    LessonAdviceType["LessonNotStarted"] = "LESSON_NOT_STARTED";
    LessonAdviceType["MeasureColumn"] = "MEASURE_COLUMN";
    LessonAdviceType["PhraseDone"] = "PHRASE_DONE";
    LessonAdviceType["PositiveInt"] = "POSITIVE_INT";
    LessonAdviceType["SimpleOpAttributeFilter"] = "SIMPLE_OP_ATTRIBUTE_FILTER";
    LessonAdviceType["SimpleOpMeasureFilter"] = "SIMPLE_OP_MEASURE_FILTER";
    LessonAdviceType["SingleColumnVersus"] = "SINGLE_COLUMN_VERSUS";
    LessonAdviceType["SortBy"] = "SORT_BY";
    LessonAdviceType["TimeBucket"] = "TIME_BUCKET";
    LessonAdviceType["TimeFilters"] = "TIME_FILTERS";
    LessonAdviceType["TopBottom"] = "TOP_BOTTOM";
    LessonAdviceType["Value1VsValue2"] = "VALUE1_VS_VALUE2";
})(LessonAdviceType || (LessonAdviceType = {}));
export var ListCategory;
(function (ListCategory) {
    ListCategory["All"] = "ALL";
    ListCategory["Favorite"] = "FAVORITE";
    ListCategory["My"] = "MY";
    ListCategory["NonFavorite"] = "NON_FAVORITE";
    ListCategory["Requested"] = "REQUESTED";
})(ListCategory || (ListCategory = {}));
export var ListType;
(function (ListType) {
    ListType["DataSource"] = "DATA_SOURCE";
    ListType["DbtConnection"] = "DBT_CONNECTION";
    ListType["File"] = "FILE";
    ListType["Folder"] = "FOLDER";
    ListType["LogicalColumn"] = "LOGICAL_COLUMN";
    ListType["LogicalRelationship"] = "LOGICAL_RELATIONSHIP";
    ListType["LogicalTable"] = "LOGICAL_TABLE";
    ListType["PinboardAnswerBook"] = "PINBOARD_ANSWER_BOOK";
    ListType["PinboardAnswerSheet"] = "PINBOARD_ANSWER_SHEET";
    ListType["QuestionAnswerBook"] = "QUESTION_ANSWER_BOOK";
    ListType["QuestionAnswerSheet"] = "QUESTION_ANSWER_SHEET";
    ListType["RTemplate"] = "R_TEMPLATE";
    ListType["Tag"] = "TAG";
    ListType["User"] = "USER";
    ListType["UserGroup"] = "USER_GROUP";
})(ListType || (ListType = {}));
export var LiveboardBorderType;
(function (LiveboardBorderType) {
    LiveboardBorderType["Curved"] = "CURVED";
    LiveboardBorderType["LiveboardBorderUnknown"] = "LIVEBOARD_BORDER_UNKNOWN";
    LiveboardBorderType["Sharp"] = "SHARP";
})(LiveboardBorderType || (LiveboardBorderType = {}));
export var LiveboardBrandColor;
(function (LiveboardBrandColor) {
    LiveboardBrandColor["LbcA"] = "LBC_A";
    LiveboardBrandColor["LbcB"] = "LBC_B";
    LiveboardBrandColor["LbcC"] = "LBC_C";
    LiveboardBrandColor["LbcD"] = "LBC_D";
    LiveboardBrandColor["LbcE"] = "LBC_E";
    LiveboardBrandColor["LbcF"] = "LBC_F";
    LiveboardBrandColor["LbcG"] = "LBC_G";
    LiveboardBrandColor["LbcH"] = "LBC_H";
    LiveboardBrandColor["LbcUnknown"] = "LBC_UNKNOWN";
})(LiveboardBrandColor || (LiveboardBrandColor = {}));
export var LiveboardDensityType;
(function (LiveboardDensityType) {
    LiveboardDensityType["LiveboardDensityUnknown"] = "LIVEBOARD_DENSITY_UNKNOWN";
    LiveboardDensityType["Loose"] = "LOOSE";
    LiveboardDensityType["Regular"] = "REGULAR";
    LiveboardDensityType["Tight"] = "TIGHT";
})(LiveboardDensityType || (LiveboardDensityType = {}));
export var LiveboardGutterType;
(function (LiveboardGutterType) {
    LiveboardGutterType["Guttered"] = "GUTTERED";
    LiveboardGutterType["Gutterless"] = "GUTTERLESS";
    LiveboardGutterType["LiveboardGutterUnknown"] = "LIVEBOARD_GUTTER_UNKNOWN";
})(LiveboardGutterType || (LiveboardGutterType = {}));
export var LogicalTableTypeEnum;
(function (LogicalTableTypeEnum) {
    LogicalTableTypeEnum["AggrWorksheet"] = "AGGR_WORKSHEET";
    LogicalTableTypeEnum["CalendarTable"] = "CALENDAR_TABLE";
    LogicalTableTypeEnum["DbView"] = "DB_VIEW";
    LogicalTableTypeEnum["MaterializedView"] = "MATERIALIZED_VIEW";
    LogicalTableTypeEnum["OneToOneLogical"] = "ONE_TO_ONE_LOGICAL";
    LogicalTableTypeEnum["PrivateWorksheet"] = "PRIVATE_WORKSHEET";
    LogicalTableTypeEnum["SqlView"] = "SQL_VIEW";
    LogicalTableTypeEnum["UserDefined"] = "USER_DEFINED";
    LogicalTableTypeEnum["Worksheet"] = "WORKSHEET";
})(LogicalTableTypeEnum || (LogicalTableTypeEnum = {}));
export var LogsValues;
(function (LogsValues) {
    LogsValues["SecurityLogs"] = "security_logs";
})(LogsValues || (LogsValues = {}));
export var LumosChoiceOptionType;
(function (LumosChoiceOptionType) {
    LumosChoiceOptionType["ColumnSelect"] = "COLUMN_SELECT";
    LumosChoiceOptionType["JoinSelect"] = "JOIN_SELECT";
    LumosChoiceOptionType["TableSelect"] = "TABLE_SELECT";
})(LumosChoiceOptionType || (LumosChoiceOptionType = {}));
export var LumosChoiceType;
(function (LumosChoiceType) {
    LumosChoiceType["MultiSelect"] = "MULTI_SELECT";
    LumosChoiceType["SingleSelect"] = "SINGLE_SELECT";
})(LumosChoiceType || (LumosChoiceType = {}));
export var MetadataSortFieldName;
(function (MetadataSortFieldName) {
    MetadataSortFieldName["Author"] = "AUTHOR";
    MetadataSortFieldName["Created"] = "CREATED";
    MetadataSortFieldName["DisplayName"] = "DISPLAY_NAME";
    MetadataSortFieldName["Modified"] = "MODIFIED";
    MetadataSortFieldName["Name"] = "NAME";
})(MetadataSortFieldName || (MetadataSortFieldName = {}));
export var MetadataSortOrder;
(function (MetadataSortOrder) {
    MetadataSortOrder["Asc"] = "ASC";
    MetadataSortOrder["Desc"] = "DESC";
})(MetadataSortOrder || (MetadataSortOrder = {}));
export var MetadataType;
(function (MetadataType) {
    MetadataType["AggrWorksheet"] = "AGGR_WORKSHEET";
    MetadataType["Answer"] = "ANSWER";
    MetadataType["Connection"] = "CONNECTION";
    MetadataType["DataSource"] = "DATA_SOURCE";
    MetadataType["DbView"] = "DB_VIEW";
    MetadataType["Filter"] = "FILTER";
    MetadataType["Liveboard"] = "LIVEBOARD";
    MetadataType["LogicalColumn"] = "LOGICAL_COLUMN";
    MetadataType["LogicalRelationship"] = "LOGICAL_RELATIONSHIP";
    MetadataType["LogicalTable"] = "LOGICAL_TABLE";
    MetadataType["OneToOneLogical"] = "ONE_TO_ONE_LOGICAL";
    MetadataType["PersonalisedView"] = "PERSONALISED_VIEW";
    MetadataType["PinboardAnswerBook"] = "PINBOARD_ANSWER_BOOK";
    MetadataType["PrivateWorksheet"] = "PRIVATE_WORKSHEET";
    MetadataType["QuestionAnswerBook"] = "QUESTION_ANSWER_BOOK";
    MetadataType["RelatedLink"] = "RELATED_LINK";
    MetadataType["ReportBook"] = "REPORT_BOOK";
    MetadataType["RowSecurity"] = "ROW_SECURITY";
    MetadataType["RTemplate"] = "R_TEMPLATE";
    MetadataType["TableFilter"] = "TABLE_FILTER";
    MetadataType["Tag"] = "TAG";
    MetadataType["User"] = "USER";
    MetadataType["UserData"] = "USER_DATA";
    MetadataType["UserDefined"] = "USER_DEFINED";
    MetadataType["UserGroup"] = "USER_GROUP";
    MetadataType["UserQuestion"] = "USER_QUESTION";
    MetadataType["UserRole"] = "USER_ROLE";
    MetadataType["Visualization"] = "VISUALIZATION";
    MetadataType["Worksheet"] = "WORKSHEET";
})(MetadataType || (MetadataType = {}));
export var Method;
(function (Method) {
    Method["Get"] = "GET";
    Method["Post"] = "POST";
})(Method || (Method = {}));
export var MonitorAlertType;
(function (MonitorAlertType) {
    MonitorAlertType["AnomalyBasedAlerts"] = "ANOMALY_BASED_ALERTS";
    MonitorAlertType["ScheduleBasedAlerts"] = "SCHEDULE_BASED_ALERTS";
    MonitorAlertType["ScheduleByAttributeBasedAlerts"] = "SCHEDULE_BY_ATTRIBUTE_BASED_ALERTS";
    MonitorAlertType["ThresholdBasedAlerts"] = "THRESHOLD_BASED_ALERTS";
    MonitorAlertType["ThresholdByAttributeBasedAlerts"] = "THRESHOLD_BY_ATTRIBUTE_BASED_ALERTS";
    MonitorAlertType["Unspecified"] = "UNSPECIFIED";
})(MonitorAlertType || (MonitorAlertType = {}));
export var MonitorRuleApiCode;
(function (MonitorRuleApiCode) {
    MonitorRuleApiCode["StatusCodeAlertAcrossAttributesDisabled"] = "STATUS_CODE_ALERT_ACROSS_ATTRIBUTES_DISABLED";
    MonitorRuleApiCode["StatusCodeAnomalyAlertDisabled"] = "STATUS_CODE_ANOMALY_ALERT_DISABLED";
    MonitorRuleApiCode["StatusCodeAutoCompleteFailure"] = "STATUS_CODE_AUTO_COMPLETE_FAILURE";
    MonitorRuleApiCode["StatusCodeCreatorNotSubscriber"] = "STATUS_CODE_CREATOR_NOT_SUBSCRIBER";
    MonitorRuleApiCode["StatusCodeDataFetchError"] = "STATUS_CODE_DATA_FETCH_ERROR";
    MonitorRuleApiCode["StatusCodeError"] = "STATUS_CODE_ERROR";
    MonitorRuleApiCode["StatusCodeHourlyKpiNotSupported"] = "STATUS_CODE_HOURLY_KPI_NOT_SUPPORTED";
    MonitorRuleApiCode["StatusCodeHtmlInAlertName"] = "STATUS_CODE_HTML_IN_ALERT_NAME";
    MonitorRuleApiCode["StatusCodeInsufficientDataError"] = "STATUS_CODE_INSUFFICIENT_DATA_ERROR";
    MonitorRuleApiCode["StatusCodeInvalidAttributeValueConfiguration"] = "STATUS_CODE_INVALID_ATTRIBUTE_VALUE_CONFIGURATION";
    MonitorRuleApiCode["StatusCodeInvalidRequest"] = "STATUS_CODE_INVALID_REQUEST";
    MonitorRuleApiCode["StatusCodeKeywordNotSupported"] = "STATUS_CODE_KEYWORD_NOT_SUPPORTED";
    MonitorRuleApiCode["StatusCodeMetricNotMonitorable"] = "STATUS_CODE_METRIC_NOT_MONITORABLE";
    MonitorRuleApiCode["StatusCodeMonitorableNotFound"] = "STATUS_CODE_MONITORABLE_NOT_FOUND";
    MonitorRuleApiCode["StatusCodeOk"] = "STATUS_CODE_OK";
    MonitorRuleApiCode["StatusCodePercentageChangeOnNonTimeseriesKpi"] = "STATUS_CODE_PERCENTAGE_CHANGE_ON_NON_TIMESERIES_KPI";
    MonitorRuleApiCode["StatusCodePermissionsNotFound"] = "STATUS_CODE_PERMISSIONS_NOT_FOUND";
    MonitorRuleApiCode["StatusCodeRuleNotFound"] = "STATUS_CODE_RULE_NOT_FOUND";
    MonitorRuleApiCode["StatusCodeTableIndependentAttributesNotSupported"] = "STATUS_CODE_TABLE_INDEPENDENT_ATTRIBUTES_NOT_SUPPORTED";
    MonitorRuleApiCode["StatusCodeTitleNotPlaintext"] = "STATUS_CODE_TITLE_NOT_PLAINTEXT";
    MonitorRuleApiCode["StatusCodeUnauthorized"] = "STATUS_CODE_UNAUTHORIZED";
    MonitorRuleApiCode["StatusCodeUnspecified"] = "STATUS_CODE_UNSPECIFIED";
    MonitorRuleApiCode["StatusCodeUnsupportedFormula"] = "STATUS_CODE_UNSUPPORTED_FORMULA";
    MonitorRuleApiCode["StatusCodeUnsupportedTimeBucket"] = "STATUS_CODE_UNSUPPORTED_TIME_BUCKET";
    MonitorRuleApiCode["StatusCodeUserAlreadySubscribed"] = "STATUS_CODE_USER_ALREADY_SUBSCRIBED";
    MonitorRuleApiCode["StatusCodeUserNotFound"] = "STATUS_CODE_USER_NOT_FOUND";
    MonitorRuleApiCode["StatusCodeUserNotSubscribed"] = "STATUS_CODE_USER_NOT_SUBSCRIBED";
})(MonitorRuleApiCode || (MonitorRuleApiCode = {}));
export var Month;
(function (Month) {
    Month["April"] = "APRIL";
    Month["August"] = "AUGUST";
    Month["December"] = "DECEMBER";
    Month["February"] = "FEBRUARY";
    Month["January"] = "JANUARY";
    Month["July"] = "JULY";
    Month["June"] = "JUNE";
    Month["March"] = "MARCH";
    Month["May"] = "MAY";
    Month["November"] = "NOVEMBER";
    Month["NumMonths"] = "NUM_MONTHS";
    Month["October"] = "OCTOBER";
    Month["September"] = "SEPTEMBER";
})(Month || (Month = {}));
export var NasStatus;
(function (NasStatus) {
    NasStatus["Configured"] = "CONFIGURED";
    NasStatus["Empty"] = "EMPTY";
    NasStatus["NotConfigured"] = "NOT_CONFIGURED";
})(NasStatus || (NasStatus = {}));
export var NegativeValueFormat;
(function (NegativeValueFormat) {
    NegativeValueFormat["BracesNodash"] = "BRACES_NODASH";
    NegativeValueFormat["PrefixDash"] = "PREFIX_DASH";
    NegativeValueFormat["SuffixDash"] = "SUFFIX_DASH";
})(NegativeValueFormat || (NegativeValueFormat = {}));
export var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel["Email"] = "EMAIL";
    NotificationChannel["Webhook"] = "WEBHOOK";
})(NotificationChannel || (NotificationChannel = {}));
export var ObjectDependency;
(function (ObjectDependency) {
    ObjectDependency["Column"] = "COLUMN";
    ObjectDependency["Dataobject"] = "DATAOBJECT";
    ObjectDependency["Join"] = "JOIN";
    ObjectDependency["Liveboard"] = "LIVEBOARD";
})(ObjectDependency || (ObjectDependency = {}));
export var ObjectType;
(function (ObjectType) {
    ObjectType["Answer"] = "ANSWER";
    ObjectType["Column"] = "COLUMN";
    ObjectType["Connection"] = "CONNECTION";
    ObjectType["Filter"] = "FILTER";
    ObjectType["Formula"] = "FORMULA";
    ObjectType["Insight"] = "INSIGHT";
    ObjectType["Pinboard"] = "PINBOARD";
    ObjectType["Relationship"] = "RELATIONSHIP";
    ObjectType["Table"] = "TABLE";
})(ObjectType || (ObjectType = {}));
export var Operators;
(function (Operators) {
    Operators["Contains"] = "CONTAINS";
    Operators["DoesNotContain"] = "DOES_NOT_CONTAIN";
    Operators["EndsWith"] = "ENDS_WITH";
    Operators["EqualTo"] = "EQUAL_TO";
    Operators["GreaterThan"] = "GREATER_THAN";
    Operators["GreaterThanEqualTo"] = "GREATER_THAN_EQUAL_TO";
    Operators["Is"] = "IS";
    Operators["IsBetween"] = "IS_BETWEEN";
    Operators["IsEmpty"] = "IS_EMPTY";
    Operators["IsNot"] = "IS_NOT";
    Operators["IsNotEmpty"] = "IS_NOT_EMPTY";
    Operators["IsNotNull"] = "IS_NOT_NULL";
    Operators["IsNull"] = "IS_NULL";
    Operators["LessThan"] = "LESS_THAN";
    Operators["LessThanEqualTo"] = "LESS_THAN_EQUAL_TO";
    Operators["NotEqualTo"] = "NOT_EQUAL_TO";
    Operators["StartsWith"] = "STARTS_WITH";
})(Operators || (Operators = {}));
export var Orientation;
(function (Orientation) {
    Orientation["Landscape"] = "LANDSCAPE";
    Orientation["Portrait"] = "PORTRAIT";
})(Orientation || (Orientation = {}));
export var OutputType;
(function (OutputType) {
    OutputType["Csv"] = "CSV";
    OutputType["None"] = "NONE";
    OutputType["Pdf"] = "PDF";
    OutputType["Png"] = "PNG";
    OutputType["Xls"] = "XLS";
    OutputType["Xlsx"] = "XLSX";
})(OutputType || (OutputType = {}));
export var PageSize;
(function (PageSize) {
    PageSize["A4"] = "A4";
})(PageSize || (PageSize = {}));
export var ParameterOwnerType;
(function (ParameterOwnerType) {
    ParameterOwnerType["Answer"] = "ANSWER";
    ParameterOwnerType["Worksheet"] = "WORKSHEET";
})(ParameterOwnerType || (ParameterOwnerType = {}));
export var ParameterValueType;
(function (ParameterValueType) {
    ParameterValueType["Any"] = "ANY";
    ParameterValueType["List"] = "LIST";
    ParameterValueType["Range"] = "RANGE";
})(ParameterValueType || (ParameterValueType = {}));
export var Partner;
(function (Partner) {
    Partner["Redshift"] = "REDSHIFT";
})(Partner || (Partner = {}));
export var PeriodicScheduleType;
(function (PeriodicScheduleType) {
    PeriodicScheduleType["Cron"] = "CRON";
    PeriodicScheduleType["Default"] = "DEFAULT";
})(PeriodicScheduleType || (PeriodicScheduleType = {}));
export var Periodicity;
(function (Periodicity) {
    Periodicity["Default"] = "DEFAULT";
    Periodicity["OneTime"] = "ONE_TIME";
    Periodicity["Periodic"] = "PERIODIC";
})(Periodicity || (Periodicity = {}));
export var PermissionLevel;
(function (PermissionLevel) {
    PermissionLevel["PermissionLevelCannotSubscribe"] = "PERMISSION_LEVEL_CANNOT_SUBSCRIBE";
    PermissionLevel["PermissionLevelCanSubscribe"] = "PERMISSION_LEVEL_CAN_SUBSCRIBE";
    PermissionLevel["PermissionLevelPermissionsNeeded"] = "PERMISSION_LEVEL_PERMISSIONS_NEEDED";
    PermissionLevel["PermissionLevelUnspecified"] = "PERMISSION_LEVEL_UNSPECIFIED";
})(PermissionLevel || (PermissionLevel = {}));
export var PhraseType;
(function (PhraseType) {
    PhraseType["AggregatedAttributeValuePhrase"] = "AGGREGATED_ATTRIBUTE_VALUE_PHRASE";
    PhraseType["AggregatedColumnPhrase"] = "AGGREGATED_COLUMN_PHRASE";
    PhraseType["Begin"] = "BEGIN";
    PhraseType["CalendarPhrase"] = "CALENDAR_PHRASE";
    PhraseType["DelimiterPhrase"] = "DELIMITER_PHRASE";
    PhraseType["End"] = "END";
    PhraseType["FilteredCountPhrase"] = "FILTERED_COUNT_PHRASE";
    PhraseType["FilterPhrase"] = "FILTER_PHRASE";
    PhraseType["FormulaPhrase"] = "FORMULA_PHRASE";
    PhraseType["ForEachPhrase"] = "FOR_EACH_PHRASE";
    PhraseType["GeofilterPhrase"] = "GEOFILTER_PHRASE";
    PhraseType["GroupByColumnPhrase"] = "GROUP_BY_COLUMN_PHRASE";
    PhraseType["GrowthPhrase"] = "GROWTH_PHRASE";
    PhraseType["HavingPhrase"] = "HAVING_PHRASE";
    PhraseType["InFilterPhrase"] = "IN_FILTER_PHRASE";
    PhraseType["InFilterSubqueryPhrase"] = "IN_FILTER_SUBQUERY_PHRASE";
    PhraseType["OfFilterPhrase"] = "OF_FILTER_PHRASE";
    PhraseType["OfPhrase"] = "OF_PHRASE";
    PhraseType["OfSortByPhrase"] = "OF_SORT_BY_PHRASE";
    PhraseType["PercentageOfFilterPhrase"] = "PERCENTAGE_OF_FILTER_PHRASE";
    PhraseType["PercentageOfPhrase"] = "PERCENTAGE_OF_PHRASE";
    PhraseType["PercentageOfSortByPhrase"] = "PERCENTAGE_OF_SORT_BY_PHRASE";
    PhraseType["PivotPhrase"] = "PIVOT_PHRASE";
    PhraseType["ShowColumnPhrase"] = "SHOW_COLUMN_PHRASE";
    PhraseType["SkipTokenPhrase"] = "SKIP_TOKEN_PHRASE";
    PhraseType["SortByPhrase"] = "SORT_BY_PHRASE";
    PhraseType["StopWordPhrase"] = "STOP_WORD_PHRASE";
    PhraseType["TopBottomFilterPhrase"] = "TOP_BOTTOM_FILTER_PHRASE";
    PhraseType["TopBottomPhrase"] = "TOP_BOTTOM_PHRASE";
    PhraseType["UndefinedPhrase"] = "UNDEFINED_PHRASE";
    PhraseType["VersusPhrase"] = "VERSUS_PHRASE";
    PhraseType["VersusSubqueryPhrase"] = "VERSUS_SUBQUERY_PHRASE";
})(PhraseType || (PhraseType = {}));
export var PinboardContainerType;
(function (PinboardContainerType) {
    PinboardContainerType["ClusterViz"] = "CLUSTER_VIZ";
    PinboardContainerType["GenericViz"] = "GENERIC_VIZ";
    PinboardContainerType["Group"] = "GROUP";
    PinboardContainerType["NoteTile"] = "NOTE_TILE";
    PinboardContainerType["PinnedAnswer"] = "PINNED_ANSWER";
    PinboardContainerType["PinnedInsight"] = "PINNED_INSIGHT";
})(PinboardContainerType || (PinboardContainerType = {}));
export var PinboardContextType;
(function (PinboardContextType) {
    PinboardContextType["AdminPinboard"] = "ADMIN_PINBOARD";
    PinboardContextType["DownloadPinboard"] = "DOWNLOAD_PINBOARD";
    PinboardContextType["EmbedPinboard"] = "EMBED_PINBOARD";
    PinboardContextType["HomePinboard"] = "HOME_PINBOARD";
    PinboardContextType["InsightPinboard"] = "INSIGHT_PINBOARD";
    PinboardContextType["KpiMonitor"] = "KPI_MONITOR";
    PinboardContextType["LearnPinboard"] = "LEARN_PINBOARD";
    PinboardContextType["SavedPinboard"] = "SAVED_PINBOARD";
})(PinboardContextType || (PinboardContextType = {}));
export var PinboardModelVersion;
(function (PinboardModelVersion) {
    PinboardModelVersion["V1"] = "V1";
    PinboardModelVersion["V2"] = "V2";
})(PinboardModelVersion || (PinboardModelVersion = {}));
export var PolicyType;
(function (PolicyType) {
    PolicyType["NoPolicy"] = "NO_POLICY";
    PolicyType["Process"] = "PROCESS";
    PolicyType["Usergroups"] = "USERGROUPS";
})(PolicyType || (PolicyType = {}));
export var PrincipalGroupType;
(function (PrincipalGroupType) {
    PrincipalGroupType["LocalGroup"] = "LOCAL_GROUP";
    PrincipalGroupType["TenantGroup"] = "TENANT_GROUP";
})(PrincipalGroupType || (PrincipalGroupType = {}));
export var PrincipalType;
(function (PrincipalType) {
    PrincipalType["LdapUser"] = "LDAP_USER";
    PrincipalType["LocalUser"] = "LOCAL_USER";
    PrincipalType["OidcUser"] = "OIDC_USER";
    PrincipalType["SamlUser"] = "SAML_USER";
    PrincipalType["Unknown"] = "UNKNOWN";
    PrincipalType["User"] = "USER";
    PrincipalType["UserGroup"] = "USER_GROUP";
})(PrincipalType || (PrincipalType = {}));
export var PrincipalVisibilityType;
(function (PrincipalVisibilityType) {
    PrincipalVisibilityType["Default"] = "DEFAULT";
    PrincipalVisibilityType["NonSharable"] = "NON_SHARABLE";
    PrincipalVisibilityType["Sharable"] = "SHARABLE";
})(PrincipalVisibilityType || (PrincipalVisibilityType = {}));
export var Privilages;
(function (Privilages) {
    Privilages["A3Analysis"] = "A3ANALYSIS";
    Privilages["Administration"] = "ADMINISTRATION";
    Privilages["ApplicationAdministration"] = "APPLICATION_ADMINISTRATION";
    Privilages["Authoring"] = "AUTHORING";
    Privilages["BackupAdministration"] = "BACKUP_ADMINISTRATION";
    Privilages["Bypassrls"] = "BYPASSRLS";
    Privilages["CanConfigureConnections"] = "CAN_CONFIGURE_CONNECTIONS";
    Privilages["CanCreateOrEditConnections"] = "CAN_CREATE_OR_EDIT_CONNECTIONS";
    Privilages["CanManageWorksheetViewsTables"] = "CAN_MANAGE_WORKSHEET_VIEWS_TABLES";
    Privilages["Datadownloading"] = "DATADOWNLOADING";
    Privilages["Datamanagement"] = "DATAMANAGEMENT";
    Privilages["Developer"] = "DEVELOPER";
    Privilages["DisablePinboardCreation"] = "DISABLE_PINBOARD_CREATION";
    Privilages["Experimentalfeatureprivilege"] = "EXPERIMENTALFEATUREPRIVILEGE";
    Privilages["GroupAdministration"] = "GROUP_ADMINISTRATION";
    Privilages["Jobscheduling"] = "JOBSCHEDULING";
    Privilages["Ranalysis"] = "RANALYSIS";
    Privilages["Sharewithall"] = "SHAREWITHALL";
    Privilages["Systemmanagement"] = "SYSTEMMANAGEMENT";
    Privilages["SystemInfoAdministration"] = "SYSTEM_INFO_ADMINISTRATION";
    Privilages["Userdatauploading"] = "USERDATAUPLOADING";
    Privilages["UserAdministration"] = "USER_ADMINISTRATION";
})(Privilages || (Privilages = {}));
export var Privileges;
(function (Privileges) {
    Privileges["A3Analysis"] = "A3ANALYSIS";
    Privileges["Administration"] = "ADMINISTRATION";
    Privileges["AllowNonEmbedFullAppAccess"] = "ALLOW_NON_EMBED_FULL_APP_ACCESS";
    Privileges["Authoring"] = "AUTHORING";
    Privileges["Bypassrls"] = "BYPASSRLS";
    Privileges["CanCreateOrEditConnections"] = "CAN_CREATE_OR_EDIT_CONNECTIONS";
    Privileges["CanManageWorksheetViewsTables"] = "CAN_MANAGE_WORKSHEET_VIEWS_TABLES";
    Privileges["Datadownloading"] = "DATADOWNLOADING";
    Privileges["Datamanagement"] = "DATAMANAGEMENT";
    Privileges["Developer"] = "DEVELOPER";
    Privileges["Experimentalfeatureprivilege"] = "EXPERIMENTALFEATUREPRIVILEGE";
    Privileges["GroupAdministration"] = "GROUP_ADMINISTRATION";
    Privileges["Jobscheduling"] = "JOBSCHEDULING";
    Privileges["Ranalysis"] = "RANALYSIS";
    Privileges["Sharewithall"] = "SHAREWITHALL";
    Privileges["Syncmanagement"] = "SYNCMANAGEMENT";
    Privileges["Userdatauploading"] = "USERDATAUPLOADING";
    Privileges["Usermanagement"] = "USERMANAGEMENT";
    Privileges["UserAdministration"] = "USER_ADMINISTRATION";
})(Privileges || (Privileges = {}));
export var Processes;
(function (Processes) {
    Processes["RowCountStats"] = "ROW_COUNT_STATS";
    Processes["SageIndexing"] = "SAGE_INDEXING";
    Processes["SageSampling"] = "SAGE_SAMPLING";
})(Processes || (Processes = {}));
export var ProgressStatusCode;
(function (ProgressStatusCode) {
    ProgressStatusCode["Completed"] = "COMPLETED";
    ProgressStatusCode["Failed"] = "FAILED";
    ProgressStatusCode["InProgress"] = "IN_PROGRESS";
    ProgressStatusCode["InQueue"] = "IN_QUEUE";
})(ProgressStatusCode || (ProgressStatusCode = {}));
export var Quarter;
(function (Quarter) {
    Quarter["NumQuarters"] = "NUM_QUARTERS";
    Quarter["Q1"] = "Q1";
    Quarter["Q2"] = "Q2";
    Quarter["Q3"] = "Q3";
    Quarter["Q4"] = "Q4";
})(Quarter || (Quarter = {}));
export var QuerableDataSourceType;
(function (QuerableDataSourceType) {
    QuerableDataSourceType["Default"] = "DEFAULT";
    QuerableDataSourceType["FileCsv"] = "FILE_CSV";
    QuerableDataSourceType["Informatica"] = "INFORMATICA";
    QuerableDataSourceType["IpaasInformatica"] = "IPAAS_INFORMATICA";
    QuerableDataSourceType["RdbmsAmazonAthena"] = "RDBMS_AMAZON_ATHENA";
    QuerableDataSourceType["RdbmsAmazonAuroraMysql"] = "RDBMS_AMAZON_AURORA_MYSQL";
    QuerableDataSourceType["RdbmsAmazonAuroraPostgresql"] = "RDBMS_AMAZON_AURORA_POSTGRESQL";
    QuerableDataSourceType["RdbmsAmazonRdsMysql"] = "RDBMS_AMAZON_RDS_MYSQL";
    QuerableDataSourceType["RdbmsAmazonRdsPostgresql"] = "RDBMS_AMAZON_RDS_POSTGRESQL";
    QuerableDataSourceType["RdbmsAzureSqlDatawarehouse"] = "RDBMS_AZURE_SQL_DATAWAREHOUSE";
    QuerableDataSourceType["RdbmsClickhouse"] = "RDBMS_CLICKHOUSE";
    QuerableDataSourceType["RdbmsDatabricks"] = "RDBMS_DATABRICKS";
    QuerableDataSourceType["RdbmsDenodo"] = "RDBMS_DENODO";
    QuerableDataSourceType["RdbmsDremio"] = "RDBMS_DREMIO";
    QuerableDataSourceType["RdbmsDrSum"] = "RDBMS_DR_SUM";
    QuerableDataSourceType["RdbmsFalcon"] = "RDBMS_FALCON";
    QuerableDataSourceType["RdbmsFalconOnprem"] = "RDBMS_FALCON_ONPREM";
    QuerableDataSourceType["RdbmsGcpAlloydbPostgresql"] = "RDBMS_GCP_ALLOYDB_POSTGRESQL";
    QuerableDataSourceType["RdbmsGcpBigquery"] = "RDBMS_GCP_BIGQUERY";
    QuerableDataSourceType["RdbmsGcpMysql"] = "RDBMS_GCP_MYSQL";
    QuerableDataSourceType["RdbmsGcpPostgresql"] = "RDBMS_GCP_POSTGRESQL";
    QuerableDataSourceType["RdbmsGcpSqlserver"] = "RDBMS_GCP_SQLSERVER";
    QuerableDataSourceType["RdbmsGenericJdbc"] = "RDBMS_GENERIC_JDBC";
    QuerableDataSourceType["RdbmsGoogleSheets"] = "RDBMS_GOOGLE_SHEETS";
    QuerableDataSourceType["RdbmsLooker"] = "RDBMS_LOOKER";
    QuerableDataSourceType["RdbmsLookerMl"] = "RDBMS_LOOKER_ML";
    QuerableDataSourceType["RdbmsMarketo"] = "RDBMS_MARKETO";
    QuerableDataSourceType["RdbmsMockDatabase"] = "RDBMS_MOCK_DATABASE";
    QuerableDataSourceType["RdbmsMode"] = "RDBMS_MODE";
    QuerableDataSourceType["RdbmsMysql"] = "RDBMS_MYSQL";
    QuerableDataSourceType["RdbmsOracle"] = "RDBMS_ORACLE";
    QuerableDataSourceType["RdbmsOracleAdw"] = "RDBMS_ORACLE_ADW";
    QuerableDataSourceType["RdbmsPostgres"] = "RDBMS_POSTGRES";
    QuerableDataSourceType["RdbmsPresto"] = "RDBMS_PRESTO";
    QuerableDataSourceType["RdbmsPrestoJdbc"] = "RDBMS_PRESTO_JDBC";
    QuerableDataSourceType["RdbmsRedshift"] = "RDBMS_REDSHIFT";
    QuerableDataSourceType["RdbmsSalesforce"] = "RDBMS_SALESFORCE";
    QuerableDataSourceType["RdbmsSapHana"] = "RDBMS_SAP_HANA";
    QuerableDataSourceType["RdbmsServiceNow"] = "RDBMS_SERVICE_NOW";
    QuerableDataSourceType["RdbmsSinglestore"] = "RDBMS_SINGLESTORE";
    QuerableDataSourceType["RdbmsSnowflake"] = "RDBMS_SNOWFLAKE";
    QuerableDataSourceType["RdbmsSqlserver"] = "RDBMS_SQLSERVER";
    QuerableDataSourceType["RdbmsTeradata"] = "RDBMS_TERADATA";
    QuerableDataSourceType["RdbmsTrino"] = "RDBMS_TRINO";
    QuerableDataSourceType["SaasSalesforce"] = "SAAS_SALESFORCE";
})(QuerableDataSourceType || (QuerableDataSourceType = {}));
export var QueryCompletionType;
(function (QueryCompletionType) {
    QueryCompletionType["NlCompletion"] = "NL_COMPLETION";
    QueryCompletionType["NlPrimingCompletion"] = "NL_PRIMING_COMPLETION";
    QueryCompletionType["PhraseHistoryOthers"] = "PHRASE_HISTORY_OTHERS";
    QueryCompletionType["PhraseHistorySelf"] = "PHRASE_HISTORY_SELF";
    QueryCompletionType["Rewrite"] = "REWRITE";
    QueryCompletionType["SearchHistoryOthers"] = "SEARCH_HISTORY_OTHERS";
    QueryCompletionType["SearchHistorySelf"] = "SEARCH_HISTORY_SELF";
    QueryCompletionType["Synonym"] = "SYNONYM";
    QueryCompletionType["Undefined"] = "UNDEFINED";
})(QueryCompletionType || (QueryCompletionType = {}));
export var QueryTemplateBoundStateType;
(function (QueryTemplateBoundStateType) {
    QueryTemplateBoundStateType["FilterColumn"] = "FILTER_COLUMN";
    QueryTemplateBoundStateType["FilterValue"] = "FILTER_VALUE";
})(QueryTemplateBoundStateType || (QueryTemplateBoundStateType = {}));
export var QueryTemplateType;
(function (QueryTemplateType) {
    QueryTemplateType["Attribute"] = "ATTRIBUTE";
    QueryTemplateType["AttributeColumn"] = "ATTRIBUTE_COLUMN";
    QueryTemplateType["ColumnOpFilter"] = "COLUMN_OP_FILTER";
    QueryTemplateType["CustomCalendar"] = "CUSTOM_CALENDAR";
    QueryTemplateType["ForEach"] = "FOR_EACH";
    QueryTemplateType["Geofilter"] = "GEOFILTER";
    QueryTemplateType["GrowthOf"] = "GROWTH_OF";
    QueryTemplateType["Having"] = "HAVING";
    QueryTemplateType["InFilter"] = "IN_FILTER";
    QueryTemplateType["Measure"] = "MEASURE";
    QueryTemplateType["MeasureColumn"] = "MEASURE_COLUMN";
    QueryTemplateType["NoSkill"] = "NO_SKILL";
    QueryTemplateType["SimpleOpAttributeFilter"] = "SIMPLE_OP_ATTRIBUTE_FILTER";
    QueryTemplateType["SimpleOpMeasureFilter"] = "SIMPLE_OP_MEASURE_FILTER";
    QueryTemplateType["SingleColumnVersus"] = "SINGLE_COLUMN_VERSUS";
    QueryTemplateType["SortBy"] = "SORT_BY";
    QueryTemplateType["TimeBucket"] = "TIME_BUCKET";
    QueryTemplateType["TimeFilters"] = "TIME_FILTERS";
    QueryTemplateType["TopBottom"] = "TOP_BOTTOM";
    QueryTemplateType["Undefined"] = "UNDEFINED";
    QueryTemplateType["Value1VsValue2"] = "VALUE1_VS_VALUE2";
})(QueryTemplateType || (QueryTemplateType = {}));
export var QueryTransformType;
(function (QueryTransformType) {
    QueryTransformType["AddAttribute"] = "ADD_ATTRIBUTE";
    QueryTransformType["AddAutoResolvedDateBucketsToTokens"] = "ADD_AUTO_RESOLVED_DATE_BUCKETS_TO_TOKENS";
    QueryTransformType["AddColumn"] = "ADD_COLUMN";
    QueryTransformType["AddEmptyGroupBy"] = "ADD_EMPTY_GROUP_BY";
    QueryTransformType["AddFilter"] = "ADD_FILTER";
    QueryTransformType["AddHavingFilter"] = "ADD_HAVING_FILTER";
    QueryTransformType["AddInFilter"] = "ADD_IN_FILTER";
    QueryTransformType["AddMeasure"] = "ADD_MEASURE";
    QueryTransformType["AddPredicateFilter"] = "ADD_PREDICATE_FILTER";
    QueryTransformType["AddSortColumn"] = "ADD_SORT_COLUMN";
    QueryTransformType["AddTimeBucketQualifier"] = "ADD_TIME_BUCKET_QUALIFIER";
    QueryTransformType["AddVersus"] = "ADD_VERSUS";
    QueryTransformType["ChangeAggregation"] = "CHANGE_AGGREGATION";
    QueryTransformType["ChangeTimeBucket"] = "CHANGE_TIME_BUCKET";
    QueryTransformType["DeprecatedAddFormula"] = "DEPRECATED_ADD_FORMULA";
    QueryTransformType["DeprecatedAddTimeBucket"] = "DEPRECATED_ADD_TIME_BUCKET";
    QueryTransformType["DeprecatedRemoveFormula"] = "DEPRECATED_REMOVE_FORMULA";
    QueryTransformType["DeprecatedRemoveTimeBucket"] = "DEPRECATED_REMOVE_TIME_BUCKET";
    QueryTransformType["DrillDown"] = "DRILL_DOWN";
    QueryTransformType["EditFilter"] = "EDIT_FILTER";
    QueryTransformType["NumTransforms"] = "NUM_TRANSFORMS";
    QueryTransformType["PopulatePeriodToDateFiltersInTokens"] = "POPULATE_PERIOD_TO_DATE_FILTERS_IN_TOKENS";
    QueryTransformType["RemoveAllDateRangeFiltersForColumn"] = "REMOVE_ALL_DATE_RANGE_FILTERS_FOR_COLUMN";
    QueryTransformType["RemoveAllFiltersForColumn"] = "REMOVE_ALL_FILTERS_FOR_COLUMN";
    QueryTransformType["RemoveAllHavingFilters"] = "REMOVE_ALL_HAVING_FILTERS";
    QueryTransformType["RemoveAllHavingFiltersByAggregate"] = "REMOVE_ALL_HAVING_FILTERS_BY_AGGREGATE";
    QueryTransformType["RemoveAllHavingFiltersByColumn"] = "REMOVE_ALL_HAVING_FILTERS_BY_COLUMN";
    QueryTransformType["RemoveAllPhrasesByColumn"] = "REMOVE_ALL_PHRASES_BY_COLUMN";
    QueryTransformType["RemoveAllSortPhrases"] = "REMOVE_ALL_SORT_PHRASES";
    QueryTransformType["RemoveColumn"] = "REMOVE_COLUMN";
    QueryTransformType["RemoveFilter"] = "REMOVE_FILTER";
    QueryTransformType["RemoveHavingFilter"] = "REMOVE_HAVING_FILTER";
    QueryTransformType["RemoveInFilter"] = "REMOVE_IN_FILTER";
    QueryTransformType["RemoveNonFilterPhrases"] = "REMOVE_NON_FILTER_PHRASES";
    QueryTransformType["RemovePredicateFilter"] = "REMOVE_PREDICATE_FILTER";
    QueryTransformType["RemoveTimeBucketQualifier"] = "REMOVE_TIME_BUCKET_QUALIFIER";
    QueryTransformType["RemoveVersus"] = "REMOVE_VERSUS";
})(QueryTransformType || (QueryTransformType = {}));
export var ROutputTypeEnum;
(function (ROutputTypeEnum) {
    ROutputTypeEnum["Csv"] = "CSV";
    ROutputTypeEnum["Png"] = "PNG";
})(ROutputTypeEnum || (ROutputTypeEnum = {}));
export var ReceiverType;
(function (ReceiverType) {
    ReceiverType["Email"] = "EMAIL";
    ReceiverType["Group"] = "GROUP";
    ReceiverType["User"] = "USER";
})(ReceiverType || (ReceiverType = {}));
export var RecognizedTokenType;
(function (RecognizedTokenType) {
    RecognizedTokenType["Any"] = "ANY";
    RecognizedTokenType["Attribute"] = "ATTRIBUTE";
    RecognizedTokenType["Bool"] = "BOOL";
    RecognizedTokenType["Calendar"] = "CALENDAR";
    RecognizedTokenType["Constant"] = "CONSTANT";
    RecognizedTokenType["Date"] = "DATE";
    RecognizedTokenType["DateBucket"] = "DATE_BUCKET";
    RecognizedTokenType["Delimiter"] = "DELIMITER";
    RecognizedTokenType["Double"] = "DOUBLE";
    RecognizedTokenType["EndFsm"] = "END_FSM";
    RecognizedTokenType["Formula"] = "FORMULA";
    RecognizedTokenType["FunctionName"] = "FUNCTION_NAME";
    RecognizedTokenType["IncludeFsm"] = "INCLUDE_FSM";
    RecognizedTokenType["Integer"] = "INTEGER";
    RecognizedTokenType["Keyword"] = "KEYWORD";
    RecognizedTokenType["MaxType"] = "MAX_TYPE";
    RecognizedTokenType["Measure"] = "MEASURE";
    RecognizedTokenType["NamedPhrase"] = "NAMED_PHRASE";
    RecognizedTokenType["Operator"] = "OPERATOR";
    RecognizedTokenType["Parameter"] = "PARAMETER";
    RecognizedTokenType["PositiveInt"] = "POSITIVE_INT";
    RecognizedTokenType["PrefixValue"] = "PREFIX_VALUE";
    RecognizedTokenType["SkipToken"] = "SKIP_TOKEN";
    RecognizedTokenType["StopWord"] = "STOP_WORD";
    RecognizedTokenType["String"] = "STRING";
    RecognizedTokenType["SubstringValue"] = "SUBSTRING_VALUE";
    RecognizedTokenType["SuffixValue"] = "SUFFIX_VALUE";
    RecognizedTokenType["TemplateArg"] = "TEMPLATE_ARG";
    RecognizedTokenType["Time"] = "TIME";
    RecognizedTokenType["Unrecognized"] = "UNRECOGNIZED";
    RecognizedTokenType["Value"] = "VALUE";
    RecognizedTokenType["Year"] = "YEAR";
})(RecognizedTokenType || (RecognizedTokenType = {}));
export var RedshiftConnectionStatus;
(function (RedshiftConnectionStatus) {
    RedshiftConnectionStatus["Active"] = "Active";
    RedshiftConnectionStatus["ConnectionFailure"] = "ConnectionFailure";
    RedshiftConnectionStatus["Inactive"] = "Inactive";
    RedshiftConnectionStatus["RuntimeFailure"] = "RuntimeFailure";
})(RedshiftConnectionStatus || (RedshiftConnectionStatus = {}));
export var ReplaceableColumnType;
(function (ReplaceableColumnType) {
    ReplaceableColumnType["Attribute"] = "ATTRIBUTE";
    ReplaceableColumnType["DateBucket"] = "DATE_BUCKET";
    ReplaceableColumnType["DateColumn"] = "DATE_COLUMN";
    ReplaceableColumnType["Measure"] = "MEASURE";
})(ReplaceableColumnType || (ReplaceableColumnType = {}));
export var ReportFormat;
(function (ReportFormat) {
    ReportFormat["Csv"] = "CSV";
    ReportFormat["Pdf"] = "PDF";
    ReportFormat["Png"] = "PNG";
    ReportFormat["Xlsx"] = "XLSX";
})(ReportFormat || (ReportFormat = {}));
export var RevertPolicy;
(function (RevertPolicy) {
    RevertPolicy["AllOrNone"] = "ALL_OR_NONE";
    RevertPolicy["Partial"] = "PARTIAL";
    RevertPolicy["PartialObject"] = "PARTIAL_OBJECT";
})(RevertPolicy || (RevertPolicy = {}));
export var SfdcOperationTypes;
(function (SfdcOperationTypes) {
    SfdcOperationTypes["Insert"] = "INSERT";
    SfdcOperationTypes["Upsert"] = "UPSERT";
})(SfdcOperationTypes || (SfdcOperationTypes = {}));
export var SageColumnAggTypes;
(function (SageColumnAggTypes) {
    SageColumnAggTypes["AggregateDistinct"] = "AGGREGATE_DISTINCT";
    SageColumnAggTypes["Average"] = "AVERAGE";
    SageColumnAggTypes["Count"] = "COUNT";
    SageColumnAggTypes["Max"] = "MAX";
    SageColumnAggTypes["Median"] = "MEDIAN";
    SageColumnAggTypes["Min"] = "MIN";
    SageColumnAggTypes["None"] = "NONE";
    SageColumnAggTypes["Percentile"] = "PERCENTILE";
    SageColumnAggTypes["Rank"] = "RANK";
    SageColumnAggTypes["RankPercentile"] = "RANK_PERCENTILE";
    SageColumnAggTypes["StdDeviation"] = "STD_DEVIATION";
    SageColumnAggTypes["Sum"] = "SUM";
    SageColumnAggTypes["UniqueCount"] = "UNIQUE_COUNT";
    SageColumnAggTypes["Variance"] = "VARIANCE";
})(SageColumnAggTypes || (SageColumnAggTypes = {}));
export var SageColumnType;
(function (SageColumnType) {
    SageColumnType["Attribute"] = "ATTRIBUTE";
    SageColumnType["Measure"] = "MEASURE";
    SageColumnType["Unknown"] = "UNKNOWN";
})(SageColumnType || (SageColumnType = {}));
export var SageCompareType;
(function (SageCompareType) {
    SageCompareType["BeginsWith"] = "BEGINS_WITH";
    SageCompareType["Bw"] = "BW";
    SageCompareType["BwInc"] = "BW_INC";
    SageCompareType["BwIncMax"] = "BW_INC_MAX";
    SageCompareType["BwIncMin"] = "BW_INC_MIN";
    SageCompareType["Contains"] = "CONTAINS";
    SageCompareType["EndsWith"] = "ENDS_WITH";
    SageCompareType["Eq"] = "EQ";
    SageCompareType["Ge"] = "GE";
    SageCompareType["Gt"] = "GT";
    SageCompareType["In"] = "IN";
    SageCompareType["Le"] = "LE";
    SageCompareType["Like"] = "LIKE";
    SageCompareType["Lt"] = "LT";
    SageCompareType["Ne"] = "NE";
    SageCompareType["NotIn"] = "NOT_IN";
})(SageCompareType || (SageCompareType = {}));
export var SageErrorCodeType;
(function (SageErrorCodeType) {
    SageErrorCodeType["AmbiguousToken"] = "AMBIGUOUS_TOKEN";
    SageErrorCodeType["BadRecognizedTokens"] = "BAD_RECOGNIZED_TOKENS";
    SageErrorCodeType["BadTokenSequence"] = "BAD_TOKEN_SEQUENCE";
    SageErrorCodeType["Cancelled"] = "CANCELLED";
    SageErrorCodeType["Failure"] = "FAILURE";
    SageErrorCodeType["ForbiddenWord"] = "FORBIDDEN_WORD";
    SageErrorCodeType["InconsistentJoinPath"] = "INCONSISTENT_JOIN_PATH";
    SageErrorCodeType["IncrementalRequestNotApplicable"] = "INCREMENTAL_REQUEST_NOT_APPLICABLE";
    SageErrorCodeType["InvalidColumn"] = "INVALID_COLUMN";
    SageErrorCodeType["InvalidJoinPath"] = "INVALID_JOIN_PATH";
    SageErrorCodeType["InvalidRequest"] = "INVALID_REQUEST";
    SageErrorCodeType["InvalidTable"] = "INVALID_TABLE";
    SageErrorCodeType["InvalidTransform"] = "INVALID_TRANSFORM";
    SageErrorCodeType["JoinPathAmbiguity"] = "JOIN_PATH_AMBIGUITY";
    SageErrorCodeType["LessonPlanUpgraded"] = "LESSON_PLAN_UPGRADED";
    SageErrorCodeType["LessonPlanUpgradeFailed"] = "LESSON_PLAN_UPGRADE_FAILED";
    SageErrorCodeType["LlmDisabled"] = "LLM_DISABLED";
    SageErrorCodeType["LlmFormat"] = "LLM_FORMAT";
    SageErrorCodeType["LlmNotEnoughQuestions"] = "LLM_NOT_ENOUGH_QUESTIONS";
    SageErrorCodeType["LlmNotFoundInPensieve"] = "LLM_NOT_FOUND_IN_PENSIEVE";
    SageErrorCodeType["LlmPensieveWriteError"] = "LLM_PENSIEVE_WRITE_ERROR";
    SageErrorCodeType["LlmUnavailable"] = "LLM_UNAVAILABLE";
    SageErrorCodeType["NestedAggrWarning"] = "NESTED_AGGR_WARNING";
    SageErrorCodeType["NestingGroupAggrNotAllowed"] = "NESTING_GROUP_AGGR_NOT_ALLOWED";
    SageErrorCodeType["NotFound"] = "NOT_FOUND";
    SageErrorCodeType["NotReady"] = "NOT_READY";
    SageErrorCodeType["NoJoinPath"] = "NO_JOIN_PATH";
    SageErrorCodeType["NoMatch"] = "NO_MATCH";
    SageErrorCodeType["PermissionDenied"] = "PERMISSION_DENIED";
    SageErrorCodeType["QueryTemplateToTemplateEntryMismatch"] = "QUERY_TEMPLATE_TO_TEMPLATE_ENTRY_MISMATCH";
    SageErrorCodeType["RelationshipGraphHasCycles"] = "RELATIONSHIP_GRAPH_HAS_CYCLES";
    SageErrorCodeType["RemoveFormulaDependencyFailure"] = "REMOVE_FORMULA_DEPENDENCY_FAILURE";
    SageErrorCodeType["Success"] = "SUCCESS";
    SageErrorCodeType["TimeOutError"] = "TIME_OUT_ERROR";
    SageErrorCodeType["UnknownUser"] = "UNKNOWN_USER";
    SageErrorCodeType["UnsupportedLanguage"] = "UNSUPPORTED_LANGUAGE";
    SageErrorCodeType["UserGroupMaskNotSet"] = "USER_GROUP_MASK_NOT_SET";
})(SageErrorCodeType || (SageErrorCodeType = {}));
export var SageFeatureFlag;
(function (SageFeatureFlag) {
    SageFeatureFlag["AutoResolveJoinAmbiguity"] = "AUTO_RESOLVE_JOIN_AMBIGUITY";
    SageFeatureFlag["DisableApproximateMatches"] = "DISABLE_APPROXIMATE_MATCHES";
    SageFeatureFlag["DisableDataBasedAutoBucketing"] = "DISABLE_DATA_BASED_AUTO_BUCKETING";
    SageFeatureFlag["DisableFollowUpSuggestions"] = "DISABLE_FOLLOW_UP_SUGGESTIONS";
    SageFeatureFlag["DisableObjectSearch"] = "DISABLE_OBJECT_SEARCH";
    SageFeatureFlag["DisableSearchHistoryLookup"] = "DISABLE_SEARCH_HISTORY_LOOKUP";
    SageFeatureFlag["DisableTokenization"] = "DISABLE_TOKENIZATION";
    SageFeatureFlag["DisableUbr"] = "DISABLE_UBR";
    SageFeatureFlag["DisableUbrFeedbackLookup"] = "DISABLE_UBR_FEEDBACK_LOOKUP";
    SageFeatureFlag["EnableDataBasedAutoBucketing"] = "ENABLE_DATA_BASED_AUTO_BUCKETING";
    SageFeatureFlag["EnableNlpTokenizer"] = "ENABLE_NLP_TOKENIZER";
    SageFeatureFlag["EnableOutOfScopeMatches"] = "ENABLE_OUT_OF_SCOPE_MATCHES";
    SageFeatureFlag["EnableRequestProfiling"] = "ENABLE_REQUEST_PROFILING";
    SageFeatureFlag["EnableSearchHistory"] = "ENABLE_SEARCH_HISTORY";
    SageFeatureFlag["LookupEnlitePreferredColumns"] = "LOOKUP_ENLITE_PREFERRED_COLUMNS";
    SageFeatureFlag["LookupOnlyColumns"] = "LOOKUP_ONLY_COLUMNS";
    SageFeatureFlag["NumFeatureFlags"] = "NUM_FEATURE_FLAGS";
    SageFeatureFlag["ShowDebugInfo"] = "SHOW_DEBUG_INFO";
    SageFeatureFlag["SingleTokenCompletionsOnly"] = "SINGLE_TOKEN_COMPLETIONS_ONLY";
    SageFeatureFlag["UseWhiteSpaceInfo"] = "USE_WHITE_SPACE_INFO";
    SageFeatureFlag["WriteRequestSnapshot"] = "WRITE_REQUEST_SNAPSHOT";
})(SageFeatureFlag || (SageFeatureFlag = {}));
export var SageJoinType;
(function (SageJoinType) {
    SageJoinType["Cross"] = "CROSS";
    SageJoinType["FullOuter"] = "FULL_OUTER";
    SageJoinType["Inner"] = "INNER";
    SageJoinType["LeftOuter"] = "LEFT_OUTER";
    SageJoinType["RightOuter"] = "RIGHT_OUTER";
})(SageJoinType || (SageJoinType = {}));
export var SageQueryIssueSeverity;
(function (SageQueryIssueSeverity) {
    SageQueryIssueSeverity["Error"] = "ERROR";
    SageQueryIssueSeverity["Warning"] = "WARNING";
})(SageQueryIssueSeverity || (SageQueryIssueSeverity = {}));
export var SageQueryIssueType;
(function (SageQueryIssueType) {
    SageQueryIssueType["AutoDisambiguation"] = "AUTO_DISAMBIGUATION";
    SageQueryIssueType["JoinPathResolutionRequired"] = "JOIN_PATH_RESOLUTION_REQUIRED";
    SageQueryIssueType["OtherBackendIssue"] = "OTHER_BACKEND_ISSUE";
})(SageQueryIssueType || (SageQueryIssueType = {}));
export var SageRequestFlag;
(function (SageRequestFlag) {
    SageRequestFlag["DoBestEffortTokenization"] = "DoBestEffortTokenization";
    SageRequestFlag["ExactMatchCompletionsOnly"] = "ExactMatchCompletionsOnly";
})(SageRequestFlag || (SageRequestFlag = {}));
export var ScheduleOps;
(function (ScheduleOps) {
    ScheduleOps["Create"] = "CREATE";
    ScheduleOps["Delete"] = "DELETE";
    ScheduleOps["Update"] = "UPDATE";
})(ScheduleOps || (ScheduleOps = {}));
export var ScheduleRunState;
(function (ScheduleRunState) {
    ScheduleRunState["Deadline"] = "DEADLINE";
    ScheduleRunState["Default"] = "DEFAULT";
    ScheduleRunState["DoesNotExist"] = "DOES_NOT_EXIST";
    ScheduleRunState["Failed"] = "FAILED";
    ScheduleRunState["Running"] = "RUNNING";
    ScheduleRunState["Success"] = "SUCCESS";
})(ScheduleRunState || (ScheduleRunState = {}));
export var ScheduleTargetType;
(function (ScheduleTargetType) {
    ScheduleTargetType["Http"] = "HTTP";
    ScheduleTargetType["Queue"] = "QUEUE";
})(ScheduleTargetType || (ScheduleTargetType = {}));
export var ScheduleType;
(function (ScheduleType) {
    ScheduleType["OnetimeSchedule"] = "ONETIME_SCHEDULE";
    ScheduleType["RecurringSchedule"] = "RECURRING_SCHEDULE";
})(ScheduleType || (ScheduleType = {}));
export var SchemaVersion;
(function (SchemaVersion) {
    SchemaVersion["V1"] = "v1";
})(SchemaVersion || (SchemaVersion = {}));
export var SearchAssistVersion;
(function (SearchAssistVersion) {
    SearchAssistVersion["V1"] = "V1";
    SearchAssistVersion["V2"] = "V2";
})(SearchAssistVersion || (SearchAssistVersion = {}));
export var SearchCacheSchedulerRunType;
(function (SearchCacheSchedulerRunType) {
    SearchCacheSchedulerRunType["AdHoc"] = "AD_HOC";
    SearchCacheSchedulerRunType["Scheduled"] = "SCHEDULED";
})(SearchCacheSchedulerRunType || (SearchCacheSchedulerRunType = {}));
export var SearchCacheStatus;
(function (SearchCacheStatus) {
    SearchCacheStatus["Empty"] = "EMPTY";
    SearchCacheStatus["Error"] = "ERROR";
    SearchCacheStatus["Inprogress"] = "INPROGRESS";
    SearchCacheStatus["Queued"] = "QUEUED";
    SearchCacheStatus["Ready"] = "READY";
    SearchCacheStatus["Stale"] = "STALE";
    SearchCacheStatus["Unknown"] = "UNKNOWN";
})(SearchCacheStatus || (SearchCacheStatus = {}));
export var SearchMetadataType;
(function (SearchMetadataType) {
    SearchMetadataType["Answer"] = "ANSWER";
    SearchMetadataType["Connection"] = "CONNECTION";
    SearchMetadataType["InsightSpec"] = "INSIGHT_SPEC";
    SearchMetadataType["Liveboard"] = "LIVEBOARD";
    SearchMetadataType["LogicalColumn"] = "LOGICAL_COLUMN";
    SearchMetadataType["LogicalRelationship"] = "LOGICAL_RELATIONSHIP";
    SearchMetadataType["LogicalTable"] = "LOGICAL_TABLE";
    SearchMetadataType["Tag"] = "TAG";
    SearchMetadataType["User"] = "USER";
    SearchMetadataType["UserGroup"] = "USER_GROUP";
})(SearchMetadataType || (SearchMetadataType = {}));
export var SecurityType;
(function (SecurityType) {
    SecurityType["Answer"] = "ANSWER";
    SecurityType["Column"] = "COLUMN";
    SecurityType["Dataobject"] = "DATAOBJECT";
    SecurityType["Liveboard"] = "LIVEBOARD";
})(SecurityType || (SecurityType = {}));
export var ShareMode;
(function (ShareMode) {
    ShareMode["Modify"] = "MODIFY";
    ShareMode["NoAccess"] = "NO_ACCESS";
    ShareMode["ReadOnly"] = "READ_ONLY";
})(ShareMode || (ShareMode = {}));
export var ShareType;
(function (ShareType) {
    ShareType["ReadOnly"] = "READ_ONLY";
})(ShareType || (ShareType = {}));
export var ShowPivotSummaryPrior;
(function (ShowPivotSummaryPrior) {
    ShowPivotSummaryPrior["Both"] = "BOTH";
    ShowPivotSummaryPrior["Columns"] = "COLUMNS";
    ShowPivotSummaryPrior["None"] = "NONE";
    ShowPivotSummaryPrior["Rows"] = "ROWS";
})(ShowPivotSummaryPrior || (ShowPivotSummaryPrior = {}));
export var SinglePointKpiStatus;
(function (SinglePointKpiStatus) {
    SinglePointKpiStatus["Complete"] = "COMPLETE";
    SinglePointKpiStatus["Done"] = "DONE";
    SinglePointKpiStatus["InProgress"] = "IN_PROGRESS";
})(SinglePointKpiStatus || (SinglePointKpiStatus = {}));
export var SnapshotStatus;
(function (SnapshotStatus) {
    SnapshotStatus["SnapshotCreateFailed"] = "SNAPSHOT_CREATE_FAILED";
    SnapshotStatus["SnapshotCreateFinished"] = "SNAPSHOT_CREATE_FINISHED";
    SnapshotStatus["SnapshotCreateStarted"] = "SNAPSHOT_CREATE_STARTED";
    SnapshotStatus["SnapshotDeleteFailed"] = "SNAPSHOT_DELETE_FAILED";
    SnapshotStatus["SnapshotDeleteScheduled"] = "SNAPSHOT_DELETE_SCHEDULED";
    SnapshotStatus["SnapshotNotFound"] = "SNAPSHOT_NOT_FOUND";
})(SnapshotStatus || (SnapshotStatus = {}));
export var SnapshotType;
(function (SnapshotType) {
    SnapshotType["Html"] = "HTML";
    SnapshotType["Jpeg"] = "JPEG";
    SnapshotType["Svg"] = "SVG";
})(SnapshotType || (SnapshotType = {}));
export var SortBy;
(function (SortBy) {
    SortBy["Author"] = "AUTHOR";
    SortBy["Created"] = "CREATED";
    SortBy["Default"] = "DEFAULT";
    SortBy["DisplayName"] = "DISPLAY_NAME";
    SortBy["LastAccessed"] = "LAST_ACCESSED";
    SortBy["Modified"] = "MODIFIED";
    SortBy["Name"] = "NAME";
    SortBy["None"] = "NONE";
    SortBy["RowCount"] = "ROW_COUNT";
    SortBy["Synced"] = "SYNCED";
    SortBy["UserState"] = "USER_STATE";
    SortBy["Views"] = "VIEWS";
})(SortBy || (SortBy = {}));
export var SortByType;
(function (SortByType) {
    SortByType["Count"] = "COUNT";
    SortByType["Value"] = "VALUE";
})(SortByType || (SortByType = {}));
export var SortOptionFieldName;
(function (SortOptionFieldName) {
    SortOptionFieldName["Author"] = "AUTHOR";
    SortOptionFieldName["Created"] = "CREATED";
    SortOptionFieldName["DisplayName"] = "DISPLAY_NAME";
    SortOptionFieldName["Modified"] = "MODIFIED";
    SortOptionFieldName["Name"] = "NAME";
})(SortOptionFieldName || (SortOptionFieldName = {}));
export var SortOptionOrder;
(function (SortOptionOrder) {
    SortOptionOrder["Asc"] = "ASC";
    SortOptionOrder["Desc"] = "DESC";
})(SortOptionOrder || (SortOptionOrder = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["Asc"] = "ASC";
    SortOrder["Default"] = "DEFAULT";
    SortOrder["Desc"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var SourceTypes;
(function (SourceTypes) {
    SourceTypes["Answer"] = "ANSWER";
    SourceTypes["Viz"] = "VIZ";
})(SourceTypes || (SourceTypes = {}));
export var SpotAppReviewStatus;
(function (SpotAppReviewStatus) {
    SpotAppReviewStatus["Published"] = "PUBLISHED";
    SpotAppReviewStatus["Rejected"] = "REJECTED";
    SpotAppReviewStatus["UnderReview"] = "UNDER_REVIEW";
})(SpotAppReviewStatus || (SpotAppReviewStatus = {}));
export var StateType;
(function (StateType) {
    StateType["Active"] = "ACTIVE";
    StateType["Expired"] = "EXPIRED";
    StateType["Inactive"] = "INACTIVE";
    StateType["Locked"] = "LOCKED";
    StateType["Pending"] = "PENDING";
})(StateType || (StateType = {}));
export var StyleConfigType;
(function (StyleConfigType) {
    StyleConfigType["All"] = "ALL";
    StyleConfigType["Group"] = "GROUP";
    StyleConfigType["Liveboard"] = "LIVEBOARD";
    StyleConfigType["Tile"] = "TILE";
})(StyleConfigType || (StyleConfigType = {}));
export var SubTypes;
(function (SubTypes) {
    SubTypes["AggrWorksheet"] = "AGGR_WORKSHEET";
    SubTypes["Dataset"] = "DATASET";
    SubTypes["OneToOneLogical"] = "ONE_TO_ONE_LOGICAL";
    SubTypes["SqlView"] = "SQL_VIEW";
    SubTypes["UserDefined"] = "USER_DEFINED";
    SubTypes["Worksheet"] = "WORKSHEET";
})(SubTypes || (SubTypes = {}));
export var SyncSourceTypes;
(function (SyncSourceTypes) {
    SyncSourceTypes["Answers"] = "Answers";
    SyncSourceTypes["Pinboard"] = "Pinboard";
    SyncSourceTypes["SqlView"] = "SqlView";
    SyncSourceTypes["View"] = "View";
})(SyncSourceTypes || (SyncSourceTypes = {}));
export var TableContentDensity;
(function (TableContentDensity) {
    TableContentDensity["Compact"] = "COMPACT";
    TableContentDensity["Regular"] = "REGULAR";
})(TableContentDensity || (TableContentDensity = {}));
export var TableTheme;
(function (TableTheme) {
    TableTheme["Outline"] = "OUTLINE";
    TableTheme["Row"] = "ROW";
    TableTheme["Zebra"] = "ZEBRA";
})(TableTheme || (TableTheme = {}));
export var TableType;
(function (TableType) {
    TableType["AggWorksheet"] = "AGG_WORKSHEET";
    TableType["BaseTable"] = "BASE_TABLE";
    TableType["QueryTable"] = "QUERY_TABLE";
    TableType["Unknown"] = "UNKNOWN";
    TableType["Worksheet"] = "WORKSHEET";
})(TableType || (TableType = {}));
export var TableVizPropVersion;
(function (TableVizPropVersion) {
    TableVizPropVersion["PreV1"] = "PRE_V1";
    TableVizPropVersion["V1"] = "V1";
})(TableVizPropVersion || (TableVizPropVersion = {}));
export var TemplateEntryType;
(function (TemplateEntryType) {
    TemplateEntryType["Text"] = "TEXT";
    TemplateEntryType["Token"] = "TOKEN";
})(TemplateEntryType || (TemplateEntryType = {}));
export var ThresholdComparator;
(function (ThresholdComparator) {
    ThresholdComparator["ComparatorEq"] = "COMPARATOR_EQ";
    ThresholdComparator["ComparatorGeq"] = "COMPARATOR_GEQ";
    ThresholdComparator["ComparatorGt"] = "COMPARATOR_GT";
    ThresholdComparator["ComparatorLeq"] = "COMPARATOR_LEQ";
    ThresholdComparator["ComparatorLt"] = "COMPARATOR_LT";
    ThresholdComparator["ComparatorNeq"] = "COMPARATOR_NEQ";
    ThresholdComparator["ComparatorUnspecified"] = "COMPARATOR_UNSPECIFIED";
})(ThresholdComparator || (ThresholdComparator = {}));
export var ThresholdPercentageChangeComparator;
(function (ThresholdPercentageChangeComparator) {
    ThresholdPercentageChangeComparator["PercentageChangeComparatorChangesBy"] = "PERCENTAGE_CHANGE_COMPARATOR_CHANGES_BY";
    ThresholdPercentageChangeComparator["PercentageChangeComparatorDecreasesBy"] = "PERCENTAGE_CHANGE_COMPARATOR_DECREASES_BY";
    ThresholdPercentageChangeComparator["PercentageChangeComparatorIncreasesBy"] = "PERCENTAGE_CHANGE_COMPARATOR_INCREASES_BY";
    ThresholdPercentageChangeComparator["PercentageChangeComparatorUnspecified"] = "PERCENTAGE_CHANGE_COMPARATOR_UNSPECIFIED";
})(ThresholdPercentageChangeComparator || (ThresholdPercentageChangeComparator = {}));
export var TileBrandColor;
(function (TileBrandColor) {
    TileBrandColor["TbcA"] = "TBC_A";
    TileBrandColor["TbcB"] = "TBC_B";
    TileBrandColor["TbcC"] = "TBC_C";
    TileBrandColor["TbcD"] = "TBC_D";
    TileBrandColor["TbcE"] = "TBC_E";
    TileBrandColor["TbcF"] = "TBC_F";
    TileBrandColor["TbcG"] = "TBC_G";
    TileBrandColor["TbcH"] = "TBC_H";
    TileBrandColor["TbcI"] = "TBC_I";
    TileBrandColor["TbcJ"] = "TBC_J";
    TileBrandColor["TbcK"] = "TBC_K";
    TileBrandColor["TbcL"] = "TBC_L";
    TileBrandColor["TbcM"] = "TBC_M";
    TileBrandColor["TbcN"] = "TBC_N";
    TileBrandColor["TbcO"] = "TBC_O";
    TileBrandColor["TbcP"] = "TBC_P";
    TileBrandColor["TbcQ"] = "TBC_Q";
    TileBrandColor["TbcUnknown"] = "TBC_UNKNOWN";
})(TileBrandColor || (TileBrandColor = {}));
export var TileColorShade;
(function (TileColorShade) {
    TileColorShade["TcsA"] = "TCS_A";
    TileColorShade["TcsB"] = "TCS_B";
    TileColorShade["TcsUnknown"] = "TCS_UNKNOWN";
})(TileColorShade || (TileColorShade = {}));
export var TileKpiColor;
(function (TileKpiColor) {
    TileKpiColor["TksA"] = "TKS_A";
    TileKpiColor["TksB"] = "TKS_B";
    TileKpiColor["TksC"] = "TKS_C";
    TileKpiColor["TksD"] = "TKS_D";
    TileKpiColor["TksE"] = "TKS_E";
    TileKpiColor["TksF"] = "TKS_F";
    TileKpiColor["TksG"] = "TKS_G";
    TileKpiColor["TksH"] = "TKS_H";
    TileKpiColor["TksI"] = "TKS_I";
    TileKpiColor["TksJ"] = "TKS_J";
    TileKpiColor["TksK"] = "TKS_K";
    TileKpiColor["TksL"] = "TKS_L";
    TileKpiColor["TksM"] = "TKS_M";
    TileKpiColor["TksN"] = "TKS_N";
    TileKpiColor["TksO"] = "TKS_O";
    TileKpiColor["TksP"] = "TKS_P";
    TileKpiColor["TksUnknown"] = "TKS_UNKNOWN";
})(TileKpiColor || (TileKpiColor = {}));
export var TimeFrequency;
(function (TimeFrequency) {
    TimeFrequency["Daily"] = "DAILY";
    TimeFrequency["Hourly"] = "HOURLY";
    TimeFrequency["Monthly"] = "MONTHLY";
    TimeFrequency["None"] = "NONE";
    TimeFrequency["Quarterly"] = "QUARTERLY";
    TimeFrequency["Weekly"] = "WEEKLY";
    TimeFrequency["Yearly"] = "YEARLY";
})(TimeFrequency || (TimeFrequency = {}));
export var TsObject;
(function (TsObject) {
    TsObject["Answer"] = "ANSWER";
    TsObject["Connection"] = "CONNECTION";
    TsObject["Dataobject"] = "DATAOBJECT";
    TsObject["Liveboard"] = "LIVEBOARD";
})(TsObject || (TsObject = {}));
export var TsObjectDetailGet;
(function (TsObjectDetailGet) {
    TsObjectDetailGet["Answer"] = "ANSWER";
    TsObjectDetailGet["Column"] = "COLUMN";
    TsObjectDetailGet["Connection"] = "CONNECTION";
    TsObjectDetailGet["Dataobject"] = "DATAOBJECT";
    TsObjectDetailGet["Join"] = "JOIN";
    TsObjectDetailGet["Liveboard"] = "LIVEBOARD";
    TsObjectDetailGet["Tag"] = "TAG";
    TsObjectDetailGet["User"] = "USER";
    TsObjectDetailGet["UserGroup"] = "USER_GROUP";
})(TsObjectDetailGet || (TsObjectDetailGet = {}));
export var TsObjectGet;
(function (TsObjectGet) {
    TsObjectGet["Answer"] = "ANSWER";
    TsObjectGet["ColumnAll"] = "COLUMN_ALL";
    TsObjectGet["ColumnCalendarTable"] = "COLUMN_CALENDAR_TABLE";
    TsObjectGet["ColumnTable"] = "COLUMN_TABLE";
    TsObjectGet["ColumnUserDefined"] = "COLUMN_USER_DEFINED";
    TsObjectGet["ColumnView"] = "COLUMN_VIEW";
    TsObjectGet["ColumnWorksheet"] = "COLUMN_WORKSHEET";
    TsObjectGet["Connection"] = "CONNECTION";
    TsObjectGet["DataobjectAll"] = "DATAOBJECT_ALL";
    TsObjectGet["DataobjectCalendarTable"] = "DATAOBJECT_CALENDAR_TABLE";
    TsObjectGet["DataobjectTable"] = "DATAOBJECT_TABLE";
    TsObjectGet["DataobjectUserDefined"] = "DATAOBJECT_USER_DEFINED";
    TsObjectGet["DataobjectView"] = "DATAOBJECT_VIEW";
    TsObjectGet["DataobjectWorksheet"] = "DATAOBJECT_WORKSHEET";
    TsObjectGet["Join"] = "JOIN";
    TsObjectGet["Liveboard"] = "LIVEBOARD";
    TsObjectGet["Tag"] = "TAG";
    TsObjectGet["User"] = "USER";
    TsObjectGet["UserGroup"] = "USER_GROUP";
})(TsObjectGet || (TsObjectGet = {}));
export var TupleType;
(function (TupleType) {
    TupleType["ChartAggregatedVal"] = "CHART_AGGREGATED_VAL";
    TupleType["Current"] = "CURRENT";
    TupleType["Custom"] = "CUSTOM";
    TupleType["LastAvailable"] = "LAST_AVAILABLE";
    TupleType["PreviousChartAggregatedVal"] = "PREVIOUS_CHART_AGGREGATED_VAL";
    TupleType["PrevAvailable"] = "PREV_AVAILABLE";
    TupleType["PrevDay"] = "PREV_DAY";
    TupleType["PrevHour"] = "PREV_HOUR";
    TupleType["PrevMonth"] = "PREV_MONTH";
    TupleType["PrevQuarter"] = "PREV_QUARTER";
    TupleType["PrevWeek"] = "PREV_WEEK";
    TupleType["PrevYear"] = "PREV_YEAR";
    TupleType["SinglePointKpiCurrent"] = "SINGLE_POINT_KPI_CURRENT";
    TupleType["SinglePointKpiPrevious"] = "SINGLE_POINT_KPI_PREVIOUS";
})(TupleType || (TupleType = {}));
export var Unit;
(function (Unit) {
    Unit["Auto"] = "AUTO";
    Unit["Billion"] = "BILLION";
    Unit["Million"] = "MILLION";
    Unit["None"] = "NONE";
    Unit["Thousands"] = "THOUSANDS";
    Unit["Trillion"] = "TRILLION";
})(Unit || (Unit = {}));
export var Users__AccountStatus;
(function (Users__AccountStatus) {
    Users__AccountStatus["Active"] = "ACTIVE";
    Users__AccountStatus["Expired"] = "EXPIRED";
    Users__AccountStatus["Inactive"] = "INACTIVE";
    Users__AccountStatus["Locked"] = "LOCKED";
    Users__AccountStatus["Pending"] = "PENDING";
})(Users__AccountStatus || (Users__AccountStatus = {}));
export var Users__AccountType;
(function (Users__AccountType) {
    Users__AccountType["LdapUser"] = "LDAP_USER";
    Users__AccountType["LocalUser"] = "LOCAL_USER";
    Users__AccountType["OidcUser"] = "OIDC_USER";
    Users__AccountType["RemoteUser"] = "REMOTE_USER";
    Users__AccountType["SamlUser"] = "SAML_USER";
})(Users__AccountType || (Users__AccountType = {}));
export var Users__FavoriteMetadata;
(function (Users__FavoriteMetadata) {
    Users__FavoriteMetadata["Answer"] = "ANSWER";
    Users__FavoriteMetadata["Connection"] = "CONNECTION";
    Users__FavoriteMetadata["Liveboard"] = "LIVEBOARD";
    Users__FavoriteMetadata["LogicalTable"] = "LOGICAL_TABLE";
})(Users__FavoriteMetadata || (Users__FavoriteMetadata = {}));
export var VcsCommitMetadataType;
(function (VcsCommitMetadataType) {
    VcsCommitMetadataType["Answer"] = "ANSWER";
    VcsCommitMetadataType["Liveboard"] = "LIVEBOARD";
    VcsCommitMetadataType["LogicalTable"] = "LOGICAL_TABLE";
})(VcsCommitMetadataType || (VcsCommitMetadataType = {}));
export var ValidEdocMetadataType;
(function (ValidEdocMetadataType) {
    ValidEdocMetadataType["ActionObject"] = "ACTION_OBJECT";
    ValidEdocMetadataType["Answer"] = "ANSWER";
    ValidEdocMetadataType["Cohort"] = "COHORT";
    ValidEdocMetadataType["ColumnAliasUdf"] = "COLUMN_ALIAS_UDF";
    ValidEdocMetadataType["ColumnSecurityRules"] = "COLUMN_SECURITY_RULES";
    ValidEdocMetadataType["Connection"] = "CONNECTION";
    ValidEdocMetadataType["Feedback"] = "FEEDBACK";
    ValidEdocMetadataType["Group"] = "GROUP";
    ValidEdocMetadataType["LogicalTable"] = "LOGICAL_TABLE";
    ValidEdocMetadataType["Model"] = "MODEL";
    ValidEdocMetadataType["MonitorAlerts"] = "MONITOR_ALERTS";
    ValidEdocMetadataType["NlInstruction"] = "NL_INSTRUCTION";
    ValidEdocMetadataType["Pinboard"] = "PINBOARD";
    ValidEdocMetadataType["PinboardAnswerBook"] = "PINBOARD_ANSWER_BOOK";
    ValidEdocMetadataType["QuestionAnswerBook"] = "QUESTION_ANSWER_BOOK";
    ValidEdocMetadataType["Role"] = "ROLE";
    ValidEdocMetadataType["SqlView"] = "SQL_VIEW";
    ValidEdocMetadataType["Table"] = "TABLE";
    ValidEdocMetadataType["User"] = "USER";
    ValidEdocMetadataType["UserGroup"] = "USER_GROUP";
    ValidEdocMetadataType["View"] = "VIEW";
    ValidEdocMetadataType["Worksheet"] = "WORKSHEET";
})(ValidEdocMetadataType || (ValidEdocMetadataType = {}));
export var VariableType;
(function (VariableType) {
    VariableType["FormulaTemplateVariable"] = "FORMULA_TEMPLATE_VARIABLE";
    VariableType["SystemVariable"] = "SYSTEM_VARIABLE";
    VariableType["Unknown"] = "UNKNOWN";
})(VariableType || (VariableType = {}));
export var Vendor;
(function (Vendor) {
    Vendor["Datarobot"] = "DATAROBOT";
    Vendor["Thoughtspot"] = "THOUGHTSPOT";
})(Vendor || (Vendor = {}));
export var ViewType;
(function (ViewType) {
    ViewType["Default"] = "DEFAULT";
    ViewType["MonitorAlert"] = "MONITOR_ALERT";
})(ViewType || (ViewType = {}));
export var Visibility;
(function (Visibility) {
    Visibility["NonSharable"] = "NON_SHARABLE";
    Visibility["Sharable"] = "SHARABLE";
})(Visibility || (Visibility = {}));
export var VisualizationQueryStatus;
(function (VisualizationQueryStatus) {
    VisualizationQueryStatus["Completed"] = "COMPLETED";
    VisualizationQueryStatus["ExecutingQuery"] = "EXECUTING_QUERY";
    VisualizationQueryStatus["InPriorityQueue"] = "IN_PRIORITY_QUEUE";
    VisualizationQueryStatus["ProcessingResults"] = "PROCESSING_RESULTS";
    VisualizationQueryStatus["Unknown"] = "UNKNOWN";
    VisualizationQueryStatus["WaitingForConnection"] = "WAITING_FOR_CONNECTION";
})(VisualizationQueryStatus || (VisualizationQueryStatus = {}));
export var WebhookAuthType;
(function (WebhookAuthType) {
    WebhookAuthType["ApiKeyType"] = "API_KEY_TYPE";
    WebhookAuthType["NoAuthType"] = "NO_AUTH_TYPE";
    WebhookAuthType["OAuth2Type"] = "O_AUTH2_TYPE";
})(WebhookAuthType || (WebhookAuthType = {}));
export var WeekDay;
(function (WeekDay) {
    WeekDay["Friday"] = "FRIDAY";
    WeekDay["Monday"] = "MONDAY";
    WeekDay["NumWeekDays"] = "NUM_WEEK_DAYS";
    WeekDay["Saturday"] = "SATURDAY";
    WeekDay["Sunday"] = "SUNDAY";
    WeekDay["Thursday"] = "THURSDAY";
    WeekDay["Tuesday"] = "TUESDAY";
    WeekDay["Wednesday"] = "WEDNESDAY";
})(WeekDay || (WeekDay = {}));
export var WorksheetRequestType;
(function (WorksheetRequestType) {
    WorksheetRequestType["AcceptJoinRecommendationsTransform"] = "ACCEPT_JOIN_RECOMMENDATIONS_TRANSFORM";
    WorksheetRequestType["AddColumnsFromDiffTablesTransformRequest"] = "ADD_COLUMNS_FROM_DIFF_TABLES_TRANSFORM_REQUEST";
    WorksheetRequestType["AddColumnsTransformRequest"] = "ADD_COLUMNS_TRANSFORM_REQUEST";
    WorksheetRequestType["AddFilterTransformRequest"] = "ADD_FILTER_TRANSFORM_REQUEST";
    WorksheetRequestType["AddSchemaTableTransformRequest"] = "ADD_SCHEMA_TABLE_TRANSFORM_REQUEST";
    WorksheetRequestType["ChatRequest"] = "CHAT_REQUEST";
    WorksheetRequestType["ClearJoinRecommendationsTransform"] = "CLEAR_JOIN_RECOMMENDATIONS_TRANSFORM";
    WorksheetRequestType["ColumnBulkEditTransform"] = "COLUMN_BULK_EDIT_TRANSFORM";
    WorksheetRequestType["ColumnCsvExportTransform"] = "COLUMN_CSV_EXPORT_TRANSFORM";
    WorksheetRequestType["ColumnCsvImportTransform"] = "COLUMN_CSV_IMPORT_TRANSFORM";
    WorksheetRequestType["ConvertGlobalToLocalJoinTransform"] = "CONVERT_GLOBAL_TO_LOCAL_JOIN_TRANSFORM";
    WorksheetRequestType["CreateSchemaJoinRequest"] = "CREATE_SCHEMA_JOIN_REQUEST";
    WorksheetRequestType["CreateWorksheetRequest"] = "CREATE_WORKSHEET_REQUEST";
    WorksheetRequestType["DeleteColumnsTransformRequest"] = "DELETE_COLUMNS_TRANSFORM_REQUEST";
    WorksheetRequestType["DeleteParameterTransformRequest"] = "DELETE_PARAMETER_TRANSFORM_REQUEST";
    WorksheetRequestType["EditFilterTransformRequest"] = "EDIT_FILTER_TRANSFORM_REQUEST";
    WorksheetRequestType["EditSchemaGraphLayoutTransform"] = "EDIT_SCHEMA_GRAPH_LAYOUT_TRANSFORM";
    WorksheetRequestType["EditSchemaJoinRequest"] = "EDIT_SCHEMA_JOIN_REQUEST";
    WorksheetRequestType["GetFormulaMetadataRequest"] = "GET_FORMULA_METADATA_REQUEST";
    WorksheetRequestType["GetJoinRecommendationsTransform"] = "GET_JOIN_RECOMMENDATIONS_TRANSFORM";
    WorksheetRequestType["GetSchemaJoinDetailsRequest"] = "GET_SCHEMA_JOIN_DETAILS_REQUEST";
    WorksheetRequestType["InitAcSessionTransformRequest"] = "INIT_AC_SESSION_TRANSFORM_REQUEST";
    WorksheetRequestType["InitAiAssistedModelingRequest"] = "INIT_AI_ASSISTED_MODELING_REQUEST";
    WorksheetRequestType["LoadWorksheetRequest"] = "LOAD_WORKSHEET_REQUEST";
    WorksheetRequestType["ParameterDependenciesRequest"] = "PARAMETER_DEPENDENCIES_REQUEST";
    WorksheetRequestType["RemoveFilterTransformRequest"] = "REMOVE_FILTER_TRANSFORM_REQUEST";
    WorksheetRequestType["RemoveFormulaTransformRequest"] = "REMOVE_FORMULA_TRANSFORM_REQUEST";
    WorksheetRequestType["RemoveSchemaJoinTransform"] = "REMOVE_SCHEMA_JOIN_TRANSFORM";
    WorksheetRequestType["RemoveSchemaTableTransform"] = "REMOVE_SCHEMA_TABLE_TRANSFORM";
    WorksheetRequestType["RenameSchemaTableTransform"] = "RENAME_SCHEMA_TABLE_TRANSFORM";
    WorksheetRequestType["SaveAsRequest"] = "SAVE_AS_REQUEST";
    WorksheetRequestType["SaveFormulaTransformRequest"] = "SAVE_FORMULA_TRANSFORM_REQUEST";
    WorksheetRequestType["SaveParameterTransformRequest"] = "SAVE_PARAMETER_TRANSFORM_REQUEST";
    WorksheetRequestType["SaveWorksheetRequest"] = "SAVE_WORKSHEET_REQUEST";
    WorksheetRequestType["SelectSchemaJoinTransform"] = "SELECT_SCHEMA_JOIN_TRANSFORM";
    WorksheetRequestType["SetScopeTransformRequest"] = "SET_SCOPE_TRANSFORM_REQUEST";
    WorksheetRequestType["UpdateColumnPropertiesTransform"] = "UPDATE_COLUMN_PROPERTIES_TRANSFORM";
    WorksheetRequestType["UpdateWorksheetNameDescriptionRequest"] = "UPDATE_WORKSHEET_NAME_DESCRIPTION_REQUEST";
    WorksheetRequestType["UpdateWorksheetPropertiesRequest"] = "UPDATE_WORKSHEET_PROPERTIES_REQUEST";
})(WorksheetRequestType || (WorksheetRequestType = {}));
export var WorksheetVersion;
(function (WorksheetVersion) {
    WorksheetVersion["V1"] = "V1";
    WorksheetVersion["V2"] = "V2";
})(WorksheetVersion || (WorksheetVersion = {}));
export var Common_FormatingType_E;
(function (Common_FormatingType_E) {
    Common_FormatingType_E["DateFormatPattern"] = "DATE_FORMAT_PATTERN";
    Common_FormatingType_E["DateTimeFormatPattern"] = "DATE_TIME_FORMAT_PATTERN";
    Common_FormatingType_E["DayInMonthFormatPattern"] = "DAY_IN_MONTH_FORMAT_PATTERN";
    Common_FormatingType_E["DayInQtrFormatPattern"] = "DAY_IN_QTR_FORMAT_PATTERN";
    Common_FormatingType_E["DayInYearFormatPattern"] = "DAY_IN_YEAR_FORMAT_PATTERN";
    Common_FormatingType_E["DayOfWeekFormatPattern"] = "DAY_OF_WEEK_FORMAT_PATTERN";
    Common_FormatingType_E["HourDateFormatPattern"] = "HOUR_DATE_FORMAT_PATTERN";
    Common_FormatingType_E["HourTimeFormatPattern"] = "HOUR_TIME_FORMAT_PATTERN";
    Common_FormatingType_E["MonthInQtrFormatPattern"] = "MONTH_IN_QTR_FORMAT_PATTERN";
    Common_FormatingType_E["MonthInYearFormatPattern"] = "MONTH_IN_YEAR_FORMAT_PATTERN";
    Common_FormatingType_E["MonthYearFormatPattern"] = "MONTH_YEAR_FORMAT_PATTERN";
    Common_FormatingType_E["NoFormating"] = "NO_FORMATING";
    Common_FormatingType_E["NumberFormatPattern"] = "NUMBER_FORMAT_PATTERN";
    Common_FormatingType_E["QtrInYearFormatPattern"] = "QTR_IN_YEAR_FORMAT_PATTERN";
    Common_FormatingType_E["QtrYearFormatPattern"] = "QTR_YEAR_FORMAT_PATTERN";
    Common_FormatingType_E["TimeFormatPattern"] = "TIME_FORMAT_PATTERN";
    Common_FormatingType_E["WeekYearFormatPattern"] = "WEEK_YEAR_FORMAT_PATTERN";
    Common_FormatingType_E["YearFormatPattern"] = "YEAR_FORMAT_PATTERN";
})(Common_FormatingType_E || (Common_FormatingType_E = {}));
export var OrientationValues;
(function (OrientationValues) {
    OrientationValues["Landscape"] = "LANDSCAPE";
    OrientationValues["Portrait"] = "PORTRAIT";
})(OrientationValues || (OrientationValues = {}));
export var Sage_MatchType_E;
(function (Sage_MatchType_E) {
    Sage_MatchType_E["Approximate"] = "APPROXIMATE";
    Sage_MatchType_E["ApproximatePrefix"] = "APPROXIMATE_PREFIX";
    Sage_MatchType_E["ApproximateWordPrefix"] = "APPROXIMATE_WORD_PREFIX";
    Sage_MatchType_E["Exact"] = "EXACT";
    Sage_MatchType_E["ExactStemmed"] = "EXACT_STEMMED";
    Sage_MatchType_E["PartialSubstring"] = "PARTIAL_SUBSTRING";
    Sage_MatchType_E["Prefix"] = "PREFIX";
    Sage_MatchType_E["Substring"] = "SUBSTRING";
    Sage_MatchType_E["Suffix"] = "SUFFIX";
    Sage_MatchType_E["Undefined"] = "UNDEFINED";
    Sage_MatchType_E["WordPrefix"] = "WORD_PREFIX";
})(Sage_MatchType_E || (Sage_MatchType_E = {}));
export var Sage_SageExpression_ExpressionClass;
(function (Sage_SageExpression_ExpressionClass) {
    Sage_SageExpression_ExpressionClass["ExprColumn"] = "EXPR_COLUMN";
    Sage_SageExpression_ExpressionClass["ExprConstant"] = "EXPR_CONSTANT";
    Sage_SageExpression_ExpressionClass["ExprFunction"] = "EXPR_FUNCTION";
    Sage_SageExpression_ExpressionClass["ExprVariable"] = "EXPR_VARIABLE";
})(Sage_SageExpression_ExpressionClass || (Sage_SageExpression_ExpressionClass = {}));
export var Sage_Auto_Complete_V2_WhiteSpaceElement_Type;
(function (Sage_Auto_Complete_V2_WhiteSpaceElement_Type) {
    Sage_Auto_Complete_V2_WhiteSpaceElement_Type["NewLine"] = "NEW_LINE";
    Sage_Auto_Complete_V2_WhiteSpaceElement_Type["Space"] = "SPACE";
})(Sage_Auto_Complete_V2_WhiteSpaceElement_Type || (Sage_Auto_Complete_V2_WhiteSpaceElement_Type = {}));
export var Sage_Auto_Complete_V2_WhiteSpaceInfo_Type;
(function (Sage_Auto_Complete_V2_WhiteSpaceInfo_Type) {
    Sage_Auto_Complete_V2_WhiteSpaceInfo_Type["Complex"] = "COMPLEX";
    Sage_Auto_Complete_V2_WhiteSpaceInfo_Type["NoWhiteSpace"] = "NO_WHITE_SPACE";
    Sage_Auto_Complete_V2_WhiteSpaceInfo_Type["SingleSpace"] = "SINGLE_SPACE";
})(Sage_Auto_Complete_V2_WhiteSpaceInfo_Type || (Sage_Auto_Complete_V2_WhiteSpaceInfo_Type = {}));
export const FormatConfigFragmentDoc = gql `
    fragment formatConfig on FormatConfig {
  category
  numberFormatConfig {
    decimals
    negativeValueFormat
    removeTrailingZeroes
    toSeparateThousands
    unit
  }
  percentageFormatConfig {
    decimals
    removeTrailingZeroes
  }
  currencyFormatConfig {
    decimals
    locale
    removeTrailingZeroes
    toSeparateThousands
    unit
  }
  customFormatConfig {
    format
  }
  isCategoryEditable
}
    `;
export const ConditionalFormattingFragmentDoc = gql `
    fragment conditionalFormatting on ConditionalFormatting {
  rows {
    backgroundFormatType
    value
    operator
    fontProperties {
      bold
      color
      italic
      strikeThrough
      underline
    }
    gradientBackgroundAttrs {
      backgroundFormatRange
      backgroundFormatMidpoint
      colors
    }
    plotAsBand
    rangeValues {
      max
      min
    }
    solidBackgroundAttrs {
      color
    }
  }
}
    `;
export const SwitchOrgDocument = gql `
    mutation switchOrg($orgId: String!) {
  Session__switchOrg(orgid: $orgId)
}
    `;
export function useSwitchOrgMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SwitchOrgDocument, options);
}
export const GetUserAccessibleOrgsDocument = gql `
    query getUserAccessibleOrgs {
  getUserAccessibleOrgs {
    Data {
      orgs {
        orgId
        orgName
        description
        allUserGroupId
        defaultAdminUserGroupId
        privileges
        isActive
      }
      canAdministerAllOrgs
      currentOrgId
    }
    Error
  }
}
    `;
export function useGetUserAccessibleOrgsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUserAccessibleOrgsDocument, options);
}
export function useGetUserAccessibleOrgsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUserAccessibleOrgsDocument, options);
}
export const GetUserAccessibleOrgsByParamsDocument = gql `
    query getUserAccessibleOrgsByParams($inputData: AccessibleOrgsInput!) {
  getUserAccessibleOrgsByParams(inputData: $inputData) {
    Data {
      orgs {
        orgId
        orgName
        description
        allUserGroupId
        defaultAdminUserGroupId
        privileges
        isActive
        nonEmbedAccess
      }
      canAdministerAllOrgs
      currentOrgId
    }
    Error
  }
}
    `;
export function useGetUserAccessibleOrgsByParamsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUserAccessibleOrgsByParamsDocument, options);
}
export function useGetUserAccessibleOrgsByParamsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUserAccessibleOrgsByParamsDocument, options);
}
//# sourceMappingURL=graphql-types.js.map